import {
  CModal,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CFormInput,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalHeader,
  CModalTitle,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormTextarea,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CTable,
  CCard,
  CCardBody,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CHeader,
  CRow,
  CCol,
  CTooltip,
  CAvatar,
  CProgress,
  CProgressBar,
} from '@coreui/react'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import PatientInfo from './PatientInfo.jsx'
import './Patient.css'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import AddPatientForm from './AddNewPatient'
import SavePatients from '../../services/general/savePatientinformation.api'
import InsuranceTab from './InsuaranceTab.jsx'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api.js'
import EditIcon from '@material-ui/icons/Edit'
import VisibilityIcon from '@material-ui/icons/Visibility'
import DeleteIcon from '@material-ui/icons/Delete'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import Pageloader from '../../components/shared/Pageloader.jsx'
import PatientPopup from './PatientPopup.jsx'
import SaveExtra from '../../services/general/saveExtraData.api.js'
import { motion } from 'framer-motion'
import { AlignLeft, ArrowDownToLine, CalendarCheck, Check, CirclePlus, Delete, Download, EllipsisVertical, FilePenLine, HardDriveUpload, Pencil, PenIcon, Plus, RefreshCcw, Table2, TrainFrontTunnel, Trash, Trash2, X } from 'lucide-react'
import { FunnelPlotOutlined } from '@ant-design/icons'
import PatientNoteDataCRUD from '../../../src/services/general/patientNoteData.api.js'
import toast from 'react-hot-toast'
import { toastConfig } from '../../../src/constants/other.config.js'
import { HiExclamationCircle, HiEye, HiPencil } from 'react-icons/hi'
import { Schedule } from '@mui/icons-material'
import PatientSuperBillData from '../../services/general/patientSuperBill.api.js'
import PatientProviderPatientInfo from './PatientProviderPatientInfo.jsx'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import { useSidebar } from '../../components/SidebarContext.jsx'
import { getAllAppointments, getAllAppointmentsDetails, getAppointmentDataID } from '../../components/shared/appointmentFilterData.jsx'
import { CircularProgress } from '@mui/material'
import AddProviderPatientForm from '../../components/shared/AppProviderPatientForm.jsx'
import PatientInfoTodaysAppointments from './PatientInfoTodaysAppointments.jsx'
import { useIndexedDB } from '../../context/IndexedContext.jsx'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api.js'
import LabCRUD from '../../services/general/LabsAPI.api.js'
import MedicineCRUD from '../../services/general/Medication.api.js'
import ImagingInformation from '../../services/general/ImagingAPI.api.js'
import logo from '../../assets/images/avatars/logo3.png'
import PatientImagingsCRUD from '../../services/general/patientImagingData.js'
import PatientMedications from '../../services/general/patientMedicationData.api'
import PatientOrdersCRUD from '../../services/general/patientOrders.api.js'
import GetQuestionBank from '../../services/general/saveQuestionBank.api'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api.js'
import InternalNotesCRUD from '../../services/general/internalNotesAPI.api.js'
import ModifyPatientHistory from '../../services/general/modifyPatientHistory.api.js'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api.js'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api.js'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api.js'
import PatientPhysicalExaminationData from '../../services/general/physicalExaminationData.api.js'

import PatientReportCRUD from '../../services/general/patientReportCrud.api.js'
import UploadPatient from './UploadPatient.jsx'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api.js'
import { Spinner } from 'react-bootstrap'
import { formatFacilityOption, getPatientFacilityParentCompany } from '../../utils/facilityParentCompany'

const ProviderTodaysAppointment3 = () => {
  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [rowClicked, setRowClicked] = useState(null)
  const [selectedFacility, setSelectedFacility] = useState({})
  const [roomNumber, setRoomNumber] = useState('')
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [insuranceList, setInsuranceList] = useState([])
  const [selectedDetails, setSelectedDetails] = useState({})
  const [activeTab, setActiveTab] = useState('patientDetails')
  const buttonList = [{ Name: 'View' }, { Name: 'Edit' }, { Name: 'Delete' }]
  const [patientID, setPatientID] = useState('')
  const [diagnosisData, setDiagnosisData] = useState([])
  var selectedDiagnosis = []
  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])
  const [facilities, setFacilities] = useState([])
  const [patientData, setPatientData] = useState('')
  const [patientCount, setPatientCount] = useState(-1)
  const [viewPatientDetail, setViewPatientDetail] = useState()
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [patientModelVisible, setPatientModalVisible] = useState(false)
  const [dataCallType, setDataCallType] = useState(null)
  const [setDataId, setEditDataId] = useState(null)
  const [showPatientInfo, setShowPatientInfo] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deletePatientID, setDeletePatientID] = useState(null)
  const [appointment, setAppointment] = useState([])
  const [appointmentPatient, setAppointmentPatient] = useState(null)
  const [appointments, setAppointments] = useState([])
  const [noteID, setNoteID] = useState(null)
  const [changesInTreatmentShell, setChangesInTreatmentShell] = useState(false)

  const [allAppointment, setAllAppointment] = useState([])
  const [noteStatus, setNoteStatus] = useState('New Note')
  const [patientAppointmentID, setPatientAppointmentID] = useState(null)
  const [patientId, setPatientId] = useState(null)
  const [creatingNewNote, setCreatingNewNote] = useState(false)
  const [superBill, setSuperBill] = useState([])
  const [scheduleTime, setScheduleTime] = useState(null)
  const [deleteModel, setDeleteModel] = useState(false)
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const [allAppointmentRawData, setAllAppointmentRawData] = useState([])
  const [showVerifyModel, setShowVerifyModel] = useState(false)
  const [hpiAdded, setHpiAdded] = useState(false)
  const [refreshCounter, setRefreshCounter] = useState(0)
  const [offlineData, setOfflineData] = useState({})
  const [patientInfoCount, setPatientInfoCount] = useState({
    followUp: 0,
    newPatient: 0,
  })
  const { isSidebarOpen, toggleSidebar, closeSidebar, openSidebar } = useSidebar()
  const [boxView, setBoxView] = useState('list')
  const [creatingPatientLoader, setCreatingPatientLoader] = useState(false)
  const [patinetWithFacilityData, setPatinetWithFacilityData] = useState(null)
  const [masterModel, setMasterModel] = useState(false)

  const [addedNewIncident, setAddedNewIncident] = useState(false)
  const [rosAdded, setRosAdded] = useState(false)

  const [verifyFormData, setVerifyFormData] = useState({
    patientSeen: true,
    notSeenReason: '',
    otherReason: '',
    term: '',
  })

  const [peAdded, setPEAdded] = useState(false)
  const {
    saveHPIDiagnosisData,
    savePEData,
    getPEData,
    getHPIDiagnosisData,
    saveEducationMaster,
    saveAssSuggMasterData,
    saveGeneralPlanStatement,
    saveDifferntialDiagnosis,
    saveImagingMasterData,
    saveLabMasterData,
    saveImagingDetailsAllMaster,
    getImagingDetailsAllMaster,
    saveMedicationMasterData,
    saveMiscellaneousMaster,
    saveAllMasterDiagnosis,
    saveAllMasterDiagnosisOptions,
    getAllMasterDiagnosis,
    saveRiskFactorMaster,
    checkIfMastersExist,
    getOfflineData,
    saveProviderList,
    saveOfflineData,
    getMedicationMasterData,
    savePOACMaster,
    getPOACMaster,
    saveProviderDetails,
    getProviderDetails,
    saveFacilityData,
    saveAllAppointmentData,
    savePatientHpi,
    saveAllTodaysAppointment,
    saveDiagnosisReponseData,
    getAllTodaysAppointment,
    saveAddedEndumen,
    saveImagingInformationData,
    saveMedicationinformationData,
    saveAllAppointmentDetails,
    getAllAppointmentDetails,
    savePatientDetails,
    saveNewPatientData,
    getNewPatientData,
    saveCallCenterQuestions,
    getPatientDetails,
    getPreSignedAppointment,
    savePreSignedAppointment,
    getPreSignedData,
    savePreSignedData,
  } = useIndexedDB()

  console.log('saveAllAppointmentDetail', saveAllAppointmentDetails)

  useEffect(() => {
    const fetchOfflineData = async () => {
      const data = await getOfflineData()
      if (data) {
        setOfflineData(data[loggedUserProvider?.ID] || {})
      }
    }
    fetchOfflineData()
  }, [loggedUserProvider?.ID])

  const [editModalVisible, setEditModalVisible] = useState(false)
  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '0',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
    Status: 'NewPatient',
  })

  const resetStates = () => {
    setChildFormData({
      FirstName: '',
      MiddleName: '',
      LastName: '',
      DOB: '',
      Gender: '',
      Age: '0',
      PhoneNumber: '',
      EmergencyName: '',
      EmergencyPhone: '',
      Address: '',
      State: '',
      City: '',
      ZipCode: '',
      Country: '',
      insurance: '',
      Status: 'NewPatient',
    })
    setRoomNumber('')
    setSelectedFacility({})
    setAddedInsurances([])
    setInsuranceList([])
    setSelectedDetails({})
    setAllSelectedDiagnosis([])
    setModalVisible(false)
    setFacility({
      facility: '',
      roomNumber: '',
    })
    setEditModalVisible(false)
  }

  const [facility, setFacility] = useState({
    facility: '',
    roomNumber: '',
  })

  useEffect(() => {
    // if sidebar is not showing on page render then show
    if (!isSidebarOpen) {
      openSidebar()
    }
  }, [])

  const [daysMap, setDaysMap] = useState({})
  const [locations, setLocations] = useState([])
  const [cancelReason, setCancelReason] = useState('')
  const [isShowRefresh, setShowIsRefresh] = useState(true)

  const patientSelected = async (rowSelected) => {
    getData()
    setViewPatientDetail(rowSelected)

    let patientInsurance = await PatientInsuranceFn('SELECTALL', '', rowSelected.PatientID)

    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
    } catch (e) { }

    try {
      let tempSelectedDiagnosis = rowSelected.Diagnosis ? rowSelected.Diagnosis.split(',') : []
      selectedDiagnosis = diagnosisData.filter((obj) => tempSelectedDiagnosis.includes(obj.label))
      setRoomNumber(rowSelected?.Room)
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      console.log('userFacilities', userFacilities, rowSelected)
      setSelectedFacility(userFacilities ? userFacilities : facilities[0])
      setAllSelectedDiagnosis(selectedDiagnosis)
    } catch (e) {
      setAllSelectedDiagnosis([])
    }

    setChildFormData({
      FirstName: rowSelected.FirstName || '',
      MiddleName: rowSelected.MiddleName || '',
      LastName: rowSelected.LastName || '',
      DOB: rowSelected.DOB || '',
      Gender: rowSelected.Gender || '',
      Age: rowSelected.Age || '0',
      PhoneNumber: rowSelected.PhoneNumber || '',
      EmergencyName: rowSelected.EmergencyName || '',
      EmergencyPhone: rowSelected.EmergencyPhone || '',
      Address: rowSelected.Address || '',
      State: rowSelected.State || '',
      City: rowSelected.City || '',
      ZipCode: rowSelected.ZipCode || '',
      Country: rowSelected.Country || '',
    })

    setSelectedDetails({ Insurances: patientInsurance })
  }

  // const getAppointmentData = async () => {

  //     try {

  //         let data = await SaveExtra('Get_By_Type', 'AppointmentsData', '', '')
  //         data = JSON.parse(data.d)?.Data || [];

  //         if (data) {
  //             data = data?.map((item) => {
  //                 return {
  //                     Id: item.Id,
  //                     Data: JSON.parse(item?.JsonData)
  //                 }
  //             })

  //         }
  //         setAppointmentDataID(data)
  //         setAppointments(data[0]?.Data)
  //         return data[0]?.Data || []
  //     } catch (error) {
  //         console.log(error)
  //     } finally {
  // setIsPageLoading(false);

  //     }
  // };

  const isManuallyScheduledAppointment = (appointment) => {
    const status = appointment?.data?.Status
    const scheduleBy = appointment?.data?.ScheduleBy
    const type = appointment?.data?.Type
    const isInFacility = appointment?.data?.isInFacility
    const priorAuth = appointment?.data?.otherDetails?.priorAuth?.isRequired

    let priorAuthTime = 0
    if (priorAuth) {
      priorAuthTime = parseInt(appointment?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
    }

    const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
    const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

    return isScheduledOrRescheduled && isManualOrFollowUp
  }

  const getProvidersMaster = async () => {
    // setIsPageLoading(true)
    try {
      // Fetch provider data
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      const getUser = JSON.parse(localStorage.getItem('user'))

      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      setLoggedUserProvider(foundProvider || {})
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const getLoggedUserId = async () => {
    try {
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      const getUser = JSON.parse(localStorage.getItem('user'))

      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      console.log('foundProvider', foundProvider, foundProvider?.ID)
      return foundProvider || null
    } catch (error) {
      console.log(error)
    }
  }

  function formatDateFilter(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    return `${mm}/${dd}/${yyyy}`
  }

  const getAppointmentData = async () => {
    setIsPageLoading(true)
    try {
      const date = formatDateFilter(new Date())

      const appointmentData = await getAllAppointments('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)
      const appointmentDetails = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)
      console.log('appointmentData-->', appointmentDetails)

      setAllAppointment(appointmentData)

      //  let flatAppointments = appointmentData.flatMap((p) => p.appointmentDetails)
      const AppointmentCount = appointmentDetails.filter((item) => isManuallyScheduledAppointment(item))
      setPatientCount(AppointmentCount.length)
      setAppointments(appointmentDetails)

      return appointmentDetails
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  console.log('todays appointment--->', appointment)
  const getDataforAppointmentTest = async (logId) => {
    const date = formatDateFilter(new Date())
    const appointmentDetails = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', date, logId)

    return appointmentDetails
  }

  const patientDataFn = async () => {
    // setIsPageLoading(true)
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      let patient = JSON.parse(patientData.d).Data
      let appointments = await getAppointmentData()
      let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))

      setPatientData(schedulePatient)
      setAppointment(appointments)

      let count = schedulePatient.length
      // setPatientCount(count)
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const getLatestAppointmentData = async () => {
    try {
      const date = formatDateFilter(new Date())

      const providerId = await getLoggedUserId()
      const appointmentDetails = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', date, providerId?.ID)
      console.log('appointmentDataaa', appointmentDetails, date, providerId)

      return appointmentDetails
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getLatestDataPatientDataFn = async () => {
    // setIsPageLoading(true)
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      let patient = JSON.parse(patientData.d).Data
      let appointments = await getLatestAppointmentData()
      let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))
      console.log('latestAppointment', patientData, appointments)
      return {
        schedulePatient,
        appointments,
      }
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const [isPatientListUpdate, setIsPatientListUpdate] = useState(false)
  const [isPatientLoadedToday, setIsPatientLoadedToday] = useState(() => {
    const stored = localStorage.getItem('isPatientListLoadedToday')
    if (!stored) return false

    return new Date(stored).toDateString() === new Date().toDateString()
  })

  const isPatientDownloadDisable = useMemo(() => {
    return isPatientLoadedToday
  }, [isPatientLoadedToday])

  const isPatientDownloadEnableShowRedBorder = useMemo(() => {
    return !isPatientLoadedToday
  }, [isPatientLoadedToday])

  const checkUploadPatientList = async () => {
    const getProviderDetailsData = await getProviderDetails()
    const data = await getOfflineData()
    if (!data) {
      return true
    }
    const DBData = data[getProviderDetailsData?.ID] || []

    const signedPatients = Object.values(DBData)?.filter((item) => item?.newlyAddedData?.currentNote?.status === 'Signed' && !item?.isUploaded)
    const checkAddonPatient = Object.values(DBData)?.filter((item) => item?.AddedByApp === true)

    console.log('signed data ', signedPatients)
    return signedPatients + checkAddonPatient
  }

  const checkCurrentPatientList = async () => {
    const cachedNotesData = await getAllTodaysAppointment()
    const uploadPatientList = await checkUploadPatientList()
    if (cachedNotesData) {
      try {
        const parsedNotes = JSON.parse(cachedNotesData)
        console.log(parsedNotes, 'parsedDataN', parsedNotes?.length)
        if (uploadPatientList.length > 0) {
          return parsedNotes?.length + uploadPatientList.length
        } else {
          return parsedNotes?.length
        }
      } catch (err) {
        return null
      }
    }
  }

  const [isCheckingPatientList, setIsCheckingPatientList] = useState(false)

  const checkIfPatientListUpdate = async () => {
    setIsCheckingPatientList(true)
    let latesDataAppointment = await getLatestDataPatientDataFn()
    const loggedUserDetails = await getLoggedUserId()
    const patientData = latesDataAppointment?.schedulePatient
    const appointment = latesDataAppointment?.appointments
    console.log('patientDataappointment', patientData, appointment)
    if (!patientData || !appointment) return

    try {
      let updatedPatients = await Promise.all(
        appointment.map(async (appt) => {
          const patient = patientData.find((p) => p.PatientID === appt?.data?.PatientID)
          if (!patient) return null

          let status = patient.noteStatus || 'Not Created'
          let flag = 'false'

          if (!appt?.data?.NoteID) {
            return
          }

          let parsedData = []
          try {
            const dataResponse = await PatientNoteDataCRUD('GET', patient.PatientID)
            parsedData = JSON.parse(dataResponse?.d)?.Data || []
            if (parsedData.length > 0) {
              const lastNote = parsedData[parsedData.length - 1]
              status = lastNote?.status || status
              flag = lastNote?.flag || 'false'
            }
          } catch (err) {
            console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
          }

          const scheduleStatus = appt?.data?.Status
          const scheduleBy = appt?.data?.ScheduleBy
          const type = appt?.data?.Type
          const isInFacility = appt?.data?.isInFacility
          const priorAuth = appt?.data?.otherDetails?.priorAuth?.isRequired
          const noteSeen = appt?.data?.patientSeen
          let priorAuthTime = 0

          if (priorAuth) {
            priorAuthTime = parseInt(appt?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
          }

          const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)

          const isScheduledOrRescheduled = (scheduleStatus === 'Scheduled' && noteSeen !== false) || (scheduleStatus === 'Rescheduled' && noteSeen !== false)

          if (!(isScheduledOrRescheduled && isManualOrFollowUp)) return null

          const providerName = appt?.current?.Provider?.label
          const scheduleDate = appt?.data?.StartTime?.split(' ')[0]

          const isProviderAppointment = providerName === loggedUserDetails?.Name

          console.log('provider name ', isProviderAppointment, loggedUserDetails?.Name)
          if (!isProviderAppointment) return null

          return {
            ...patient,
            noteStatus: status,
            noteFlag: flag,
          }
        }),
      )
      console.log('updatedPatients', updatedPatients)
      updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft'))

      const currentList = await checkCurrentPatientList()

      console.log('currentList', currentList, updatedPatients.length, updatedPatients)
      if (updatedPatients.length > 0) {
        if (currentList !== updatedPatients.length) {
          setIsPatientListUpdate(true)
        }
      }
      setIsCheckingPatientList(false)
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      setIsRefreshLoad(false)
      // toast.error('Error in patient treatment', toastConfig)
    }
  }

  useEffect(() => {
    getProvidersMaster()
    checkIfPatientListUpdate()
  }, [])

  const getData = async () => {
    // let a = await GetDiagnosisData()
    let a = await getAllMasterDiagnosis()

    // let data = JSON.parse(a.d)
    let options = []
    a?.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)

    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data

    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map(formatFacilityOption)
      setFacilities(formattedData)
      setSelectedFacility(formattedData[0])
    } catch (e) { }
  }

  const [modalVisible, setModalVisible] = useState(false)

  const patientSelectedFacility = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)

      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) { }
  }

  const saveDiagnosisData = async (customData) => {
    let a = {}
    let facility = await patientSelectedFacility(customData)

    try {
      a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
      a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
      a['Room'] = customData?.Room?.toString() || roomNumber.toString()
    } catch (e) {
      a['FacilityID'] = ''
      a['FacilityName'] = ''
      a['Room'] = -1
    }

    let allDiagnosis = customData?.Diagnosis || ''

    let insurances = addedInsurances.map((ins) => ({
      InsuranceID: ins?.ID,
    }))

    let savePatientInfo
    if (patientID && patientID !== '') {
      savePatientInfo = SavePatients('Update', JSON.stringify(customData ? customData : childformData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
    }

    // await savePatientInfo;

    await patientDataFn()
    // resetStates()
  }

  useEffect(() => {
    getAppointmentData()
    getData()
    patientDataFn()
    getFacilities()
  }, [loggedUserProvider])

  const noteStructureRef = useRef({})

  const [showFilter, setShowFilter] = useState(false)
  const [filterData, setFilterData] = useState({
    facility: [],
    searchValue: '',
    scheduleDate: '',
    date: '',
    status: [],
  })
  const [filteredPatientData, setFilteredPatientData] = useState([])

  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
  ]

  // const GetPatientTreatmentsNotes = async () => {
  // if (!patientData || !appointment) return

  //   try {
  //     let updatedPatients = await Promise.all(
  //       patientData.map(async (patient) => {
  //         let status = patient.noteStatus || 'Not Created' // Default status
  //         let flag = 'false' // Default flag

  //         try {
  //           const dataResponse = await PatientNoteDataCRUD('GET', patient?.PatientID)
  //           const parsedData = JSON.parse(dataResponse?.d)?.Data

  //           if (Array.isArray(parsedData) && parsedData.length > 0) {
  //             status = parsedData[parsedData.length - 1]?.status || status
  //             flag = parsedData[parsedData.length - 1]?.flag || 'false'
  //           }
  //         } catch (err) {
  //           console.error(`Error fetching notes for   patient ${patient?.PatientID}:`, err)
  //         }

  //         const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

  //         // let providerName = provider[0]?.current?.Provider?.label;
  //         // let scheduleDate = provider[0]?.data?.StartTime
  //         // scheduleDate = scheduleDate?.split(" ")
  //         // console.log("patient data ===>", patient, provider, updatedFilteredPatients)

  //         const scheduledAppointment = patientAppointments.find((p) => {
  //           const status = p?.data?.Status
  //           const scheduleBy = p?.data?.ScheduleBy
  //           const type = p?.data?.Type
  //           const isInFacility = p?.data?.isInFacility
  //           const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
  //           const noteSeen = p?.data?.patientSeen
  //           const AppointmentID = p?.data?.AppointmentID
  //           let priorAuthTime = 0
  //           if (priorAuth) {
  //             priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
  //           }

  //           // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
  //           const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
  //           const isScheduledOrRescheduled = (status === 'Scheduled' && noteSeen !== false) || (status === 'Rescheduled' && noteSeen !== false)

  //           return isScheduledOrRescheduled && isManualOrFollowUp
  //         })

  //         if (!scheduledAppointment) return null

  //         const providerName = scheduledAppointment?.current?.Provider?.label
  //         const scheduleDate = scheduledAppointment?.data?.StartTime?.split(' ')[0]
  //         const Type = scheduledAppointment?.data?.Type

  //         const isProviderAppointment = providerName === loggedUserProvider?.Name

  //         if (!isProviderAppointment) return null

  //         return {
  //           ...patient,
  //           noteStatus: status,
  //           noteFlag: flag,
  //           appointmentScheduleDate: scheduleDate,
  //           appointmentID: scheduledAppointment?.data?.AppointmentID,
  //           patientTerm: scheduledAppointment?.data?.term || '',
  //           ...(typeof scheduledAppointment?.data?.patientSeen === 'boolean' && {
  //             patientSeen: scheduledAppointment.data.patientSeen,
  //             notSeenReason: scheduledAppointment.data.notSeenReason,
  //           }),
  //         }
  //       }),
  //     )

  //     // updatedPatients = updatedPatients.filter(item => item.noteStatus === "Submitted")
  //     updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag == 'true' && item?.noteStatus == 'Draft'))

  //     setFilteredPatientData(updatedPatients)
  //   } catch (error) {
  //     console.error('Error fetching patient orders', error)
  //     // toast.error('Error in patient treatment', toastConfig);
  //   }
  // }

  const [isRefreshLoad, setIsRefreshLoad] = useState(false)
  const [isRefreshLoadForParticulatPatient, setIsRefreshLoadForParticulatPatient] = useState(false)
  const [appointmentProgress, setAppointmentProgress] = useState(0)

  const GetAppointmentsAllDataInDb = async (updatedPatients) => {
    const totalCalls = 2 + updatedPatients.length * 16 + 3
    const progressStep = 100 / totalCalls

    const incrementProgress = () => {
      setAppointmentProgress((p) => Math.min(p + progressStep, 100))
    }

    //    await patientDataFn()
    // let appointments = await getAppointmentData()
    incrementProgress()
    // setAppointment(appointments)
    //  setIsRefreshLoad(true)
    console.log('appointment--->', appointment)
    if (!patientData || !appointment) return

    try {
      const nestedStructure = {}
      const imagingTypeList = (await getImagingDetailsAllMaster()) || []
      incrementProgress()

      console.log(imagingTypeList, 'imagingTypeList')

      await Promise.all(
        updatedPatients.map(async (patient) => {
          const providerId = loggedUserProvider?.ID
          if (!nestedStructure[providerId]) nestedStructure[providerId] = {}

          const lastNote = patient?.allNotes?.[patient?.allNotes.length - 1] || {}
          let parsedNoteData = {}

          // imaginggs fetching and formatting
          let imagings = []
          let formattedData = await PatientImagingsCRUD('GET', patient?.PatientID?.toString())
          incrementProgress()
          if (formattedData) {
            formattedData = JSON.parse(formattedData.d)
            formattedData = formattedData.Data.map((item) => {
              const parsedData = JSON.parse(item.data)
              const matchingType = parsedData && imagingTypeList.find((type) => type.Name.toString() === parsedData.name.toString())
              console.log(matchingType, 'matchingType for imaging', parsedData.name)
              return {
                ...item,
                data: {
                  ...parsedData,
                  keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
                },
              }
            }).sort((a, b) => new Date(b?.date) - new Date(a?.date))
            imagings = formattedData
          }

          try {
            parsedNoteData = typeof lastNote?.data === 'string' ? JSON.parse(lastNote.data) : lastNote?.data || {}
          } catch (err) {
            parsedNoteData = {}
          }

          console.log(imagings, 'imagings for patient', patient.PatientID)

          // medication fetching and formatting
          let formattedDataMeds
          const masterMedications = (await getMedicationMasterData()) || []
          console.log(masterMedications, 'masterMedications')
          const responseMed = await PatientMedications('GET', patient?.PatientID?.toString())
          incrementProgress()
          formattedDataMeds = JSON.parse(responseMed?.d)
          formattedDataMeds = formattedDataMeds?.Data

          const masterMedsNames = masterMedications.map((med) => med.Data?.name?.toLowerCase())

          if (formattedDataMeds) {
            formattedDataMeds = formattedDataMeds.map((item) => {
              let parsedData = []
              try {
                parsedData = item.data ? JSON.parse(item.data) : []
              } catch (e) {
                console.error('Error parsing item.data:', e, item.data)
              }

              const updatedData = Array.isArray(parsedData)
                ? parsedData.map((med) => ({
                  ...med,
                  inMaster: masterMedsNames.includes(med?.name?.toLowerCase()),
                }))
                : []
              updatedData.sort((a, b) => (a.inMaster === b.inMaster ? 0 : a.inMaster ? -1 : 1))

              return {
                ...item,
                data: updatedData,
              }
            })
          }

          formattedDataMeds.sort((a, b) => new Date(b?.date) - new Date(a?.date))
          console.log(formattedDataMeds, 'formattedDataMeds for patient medications')

          // Orders fetching and formatting
          let dataOrders = await PatientOrdersCRUD('Get', '', patient?.PatientID)
          incrementProgress()

          dataOrders = JSON.parse(dataOrders?.d).Data || []
          console.log(dataOrders, 'dataOrders for patientname', patient?.FirstName)
          const parsedOrders = dataOrders?.map((order) => {
            let parsedDataMeds = []
            try {
              parsedDataMeds = order.medication ? JSON.parse(order.medication) : []
            } catch (e) {
              console.error('Error parsing order.data:', e, order.data)
            }
            return {
              id: order.id,
              date: order.date,
              medication: parsedDataMeds,
            }
          })
          // .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

          let tempAnswersGetPatientDiagnosisDetails = await GetPatientDiagnosisDetails(patient?.PatientID)
          incrementProgress()

          console.log('Past Orders:', noteID, parseInt(noteID), parsedOrders)
          const intenalNotes = await getPatientInternalNotes(patient.PatientID)
          incrementProgress()
          const hospitalRecords = await getHospitalRecord(patient.PatientID)
          incrementProgress()
          const patientHistories = await getDataPersonalHistoryInNote(patient.PatientID)
          incrementProgress()
          const patientAllergy = await getPatientAllergy(patient.PatientID)
          incrementProgress()
          const patientVitals = await getPatientVitals(patient.PatientID)
          incrementProgress()
          const labData = await fetchPatientLabs(patient.PatientID)
          incrementProgress()
          const PEPatientData = await getPatientPhysicalExamination(patient.PatientID)
          incrementProgress()
          const patientSuperBill = await getPatientSuperBill(patient.PatientID)
          incrementProgress()

          const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous']
          const formattedDataReport = {
            // [oneofsection] : data
          }

          for (const sections of threeSections) {
            let formattedData
            formattedData = await PatientReportCRUD('GET', patient?.PatientID?.toString(), '', sections.toString())

            if (formattedData) {
              formattedData = JSON.parse(formattedData.d)?.Data
              formattedData = formattedData.map((item) => {
                return {
                  ...item,
                  data: JSON.parse(item.data),
                }
              })
            }
            for (const item of formattedData || []) {
              for (const file of item.data) {
                if (file?.url) {
                  try {
                    const response = await fetch(file.url)
                    const blob = await response.blob()

                    const blobUrl = URL.createObjectURL(blob)

                    file.blobUrl = blobUrl

                    console.log(`Added blobUrl for ${file.id || item.id}:`, blobUrl)
                  } catch (error) {
                    console.error('Failed to fetch or convert image to blob:', error)
                  }
                }
              }
            }

            formattedDataReport[sections] = formattedData || []
          }
          incrementProgress()

          let diagnosisDataIndexed = await ModifyPatientMap('GETALL', patient?.PatientID, '')
          let tempData = JSON.parse(diagnosisDataIndexed.d)?.Data

          diagnosisDataIndexed = tempData.filter((obj) => {
            if (patient?.PatientID == obj.PatientID) {
              return obj
            }
          })
          incrementProgress()

          nestedStructure[providerId][patient.PatientID] = {
            details: patient.patientData,
            currentNote: {
              ...lastNote,
              data: parsedNoteData,
            },
            tempAnswersGetPatientDiagnosisDetails,
            appointmentData: patient.appointmentData,
            appointmentId: patient.appointmentID,
            totalNotes: patient.allNotes.length || 0,
            allImaging: imagings || [],
            ordersData: parsedOrders || [],
            allMedications: formattedDataMeds || [],
            interNote: intenalNotes || [],
            isFirstNote: patient.allNotes.length === 0,
            allNotes: patient.allNotes || [],
            isDetailsSyncedWithServer: false,
            hospitalRecords: hospitalRecords || [],
            patientHistories: patientHistories || {},
            patientAllergy: patientAllergy,
            patientVitals: patientVitals,
            patientLabData: labData,
            PEPatientData: PEPatientData,
            reportData: formattedDataReport,
            patientSuperBill: patientSuperBill,
            diagnosisDataModifyMap: diagnosisDataIndexed || [],
            patientData: patient,
            newPatientDiagnosis: [],
            finalDiagnosis: '',
            isDiagnosisAdded: false,
          }
        }),
      )

      let dataHPiPatient = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      incrementProgress()
      dataHPiPatient = JSON.parse(dataHPiPatient?.d)
      await savePatientHpi(dataHPiPatient)

      let dataEndum = await SaveExtra('Get_By_Type', 'Addendum', '', '')
      incrementProgress()
      dataEndum = JSON.parse(dataEndum?.d)?.Data || []
      await saveAddedEndumen(dataEndum)

      console.log(nestedStructure, 'nestedStructure', updatedPatients)
      await checkIfMastersExist()
      await saveOfflineData(nestedStructure)

      setAppointmentProgress(100)
      // setFilteredPatientData(updatedPatients)

      //  setIsRefreshLoad(false)
      // toast.success('All appointments data synced successfully', toastConfig);
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      //  setIsRefreshLoad(false)
    }
  }

  const GetAppointmentsAllDataInDbForParticular = async (updatedPatients) => {
    const totalCalls = 2 + updatedPatients.length * 16 + 3
    const progressStep = 100 / totalCalls

    const incrementProgress = () => {
      setAppointmentProgress((p) => Math.min(p + progressStep, 100))
    }

    //    await patientDataFn()
    let appointments = await getAppointmentData()
    incrementProgress()
    setAppointment(appointments)
    //  setIsRefreshLoad(true)
    console.log('appointment--->', appointment)
    if (!patientData || !appointment) return

    try {
      const nestedStructure = {}
      const getOfflineDataAlreadyStored = await getOfflineData()

      const imagingTypeList = (await getImagingDetailsAllMaster()) || []
      incrementProgress()

      console.log(imagingTypeList, 'imagingTypeList')

      await Promise.all(
        updatedPatients.map(async (patient) => {
          const providerId = loggedUserProvider?.ID
          if (!nestedStructure[providerId]) nestedStructure[providerId] = {}

          const lastNote = patient?.allNotes?.[patient?.allNotes.length - 1] || {}
          let parsedNoteData = {}

          // imaginggs fetching and formatting
          let imagings = []
          let formattedData = await PatientImagingsCRUD('GET', patient?.PatientID?.toString())
          incrementProgress()
          if (formattedData) {
            formattedData = JSON.parse(formattedData.d)
            formattedData = formattedData.Data.map((item) => {
              const parsedData = JSON.parse(item.data)
              const matchingType = parsedData && imagingTypeList.find((type) => type.Name.toString() === parsedData.name.toString())
              console.log(matchingType, 'matchingType for imaging', parsedData.name)
              return {
                ...item,
                data: {
                  ...parsedData,
                  keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
                },
              }
            }).sort((a, b) => new Date(b?.date) - new Date(a?.date))
            imagings = formattedData
          }

          try {
            parsedNoteData = typeof lastNote?.data === 'string' ? JSON.parse(lastNote.data) : lastNote?.data || {}
          } catch (err) {
            parsedNoteData = {}
          }

          console.log(imagings, 'imagings for patient', patient.PatientID)

          // medication fetching and formatting
          let formattedDataMeds
          const masterMedications = (await getMedicationMasterData()) || []
          console.log(masterMedications, 'masterMedications')
          const responseMed = await PatientMedications('GET', patient?.PatientID?.toString())
          incrementProgress()
          formattedDataMeds = JSON.parse(responseMed?.d)
          formattedDataMeds = formattedDataMeds?.Data

          const masterMedsNames = masterMedications.map((med) => med.Data?.name?.toLowerCase())

          if (formattedDataMeds) {
            formattedDataMeds = formattedDataMeds.map((item) => {
              let parsedData = []
              try {
                parsedData = item.data ? JSON.parse(item.data) : []
              } catch (e) {
                console.error('Error parsing item.data:', e, item.data)
              }

              const updatedData = Array.isArray(parsedData)
                ? parsedData.map((med) => ({
                  ...med,
                  inMaster: masterMedsNames.includes(med?.name?.toLowerCase()),
                }))
                : []
              updatedData.sort((a, b) => (a.inMaster === b.inMaster ? 0 : a.inMaster ? -1 : 1))

              return {
                ...item,
                data: updatedData,
              }
            })
          }

          formattedDataMeds.sort((a, b) => new Date(b?.date) - new Date(a?.date))
          console.log(formattedDataMeds, 'formattedDataMeds for patient medications')

          // Orders fetching and formatting
          let dataOrders = await PatientOrdersCRUD('Get', '', patient?.PatientID)
          incrementProgress()

          dataOrders = JSON.parse(dataOrders?.d).Data || []
          console.log(dataOrders, 'dataOrders for patientname', patient?.FirstName)
          const parsedOrders = dataOrders?.map((order) => {
            let parsedDataMeds = []
            try {
              parsedDataMeds = order.medication ? JSON.parse(order.medication) : []
            } catch (e) {
              console.error('Error parsing order.data:', e, order.data)
            }
            return {
              id: order.id,
              date: order.date,
              medication: parsedDataMeds,
            }
          })
          // .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

          let tempAnswersGetPatientDiagnosisDetails = await GetPatientDiagnosisDetails(patient?.PatientID)
          incrementProgress()

          console.log('Past Orders:', noteID, parseInt(noteID), parsedOrders)
          const intenalNotes = await getPatientInternalNotes(patient.PatientID)
          incrementProgress()
          const hospitalRecords = await getHospitalRecord(patient.PatientID)
          incrementProgress()
          const patientHistories = await getDataPersonalHistoryInNote(patient.PatientID)
          incrementProgress()
          const patientAllergy = await getPatientAllergy(patient.PatientID)
          incrementProgress()
          const patientVitals = await getPatientVitals(patient.PatientID)
          incrementProgress()
          const labData = await fetchPatientLabs(patient.PatientID)
          incrementProgress()
          const PEPatientData = await getPatientPhysicalExamination(patient.PatientID)
          incrementProgress()
          const patientSuperBill = await getPatientSuperBill(patient.PatientID)
          incrementProgress()

          const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous']
          const formattedDataReport = {
            // [oneofsection] : data
          }

          for (const sections of threeSections) {
            let formattedData
            formattedData = await PatientReportCRUD('GET', patient?.PatientID?.toString(), '', sections.toString())

            if (formattedData) {
              formattedData = JSON.parse(formattedData.d)?.Data
              formattedData = formattedData.map((item) => {
                return {
                  ...item,
                  data: JSON.parse(item.data),
                }
              })
            }
            for (const item of formattedData || []) {
              for (const file of item.data) {
                if (file?.url) {
                  try {
                    const response = await fetch(file.url)
                    const blob = await response.blob()

                    const blobUrl = URL.createObjectURL(blob)

                    file.blobUrl = blobUrl

                    console.log(`Added blobUrl for ${file.id || item.id}:`, blobUrl)
                  } catch (error) {
                    console.error('Failed to fetch or convert image to blob:', error)
                  }
                }
              }
            }

            formattedDataReport[sections] = formattedData || []
          }
          incrementProgress()

          nestedStructure[providerId][patient.PatientID] = {
            details: patient.patientData,
            currentNote: {
              ...lastNote,
              data: parsedNoteData,
            },
            tempAnswersGetPatientDiagnosisDetails,
            appointmentData: patient.appointmentData,
            appointmentId: patient.appointmentID,
            totalNotes: patient.allNotes.length || 0,
            allImaging: imagings || [],
            ordersData: parsedOrders || [],
            allMedications: formattedDataMeds || [],
            interNote: intenalNotes || [],
            isFirstNote: patient.allNotes.length === 0,
            allNotes: patient.allNotes || [],
            isDetailsSyncedWithServer: false,
            hospitalRecords: hospitalRecords || [],
            patientHistories: patientHistories || {},
            patientAllergy: patientAllergy,
            patientVitals: patientVitals,
            patientLabData: labData,
            PEPatientData: PEPatientData,
            reportData: formattedDataReport,
            patientSuperBill: patientSuperBill,
            patientData: patient,
            newPatientDiagnosis: [],
            finalDiagnosis: '',
            isDiagnosisAdded: false,
          }
        }),
      )

      const existingOffline = (await getOfflineData()) || {}
      const providerId = loggedUserProvider?.ID

      if (!existingOffline[providerId]) {
        existingOffline[providerId] = {}
      }

      updatedPatients.forEach((patient) => {
        const pid = patient.PatientID

        Object.keys(existingOffline[providerId]).forEach((oldPid) => {
          if (parseInt(oldPid) !== pid) {
            nestedStructure[providerId][oldPid] = existingOffline[providerId][oldPid]
          }
        })
      })
      console.log(nestedStructure, getOfflineDataAlreadyStored, getOfflineDataAlreadyStored[loggedUserProvider?.ID], loggedUserProvider, loggedUserProvider?.ID, 'getOfflineDataAlreadyStored after')

      let dataHPiPatient = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      incrementProgress()
      dataHPiPatient = JSON.parse(dataHPiPatient?.d)
      await savePatientHpi(dataHPiPatient)

      let dataEndum = await SaveExtra('Get_By_Type', 'Addendum', '', '')
      incrementProgress()
      dataEndum = JSON.parse(dataEndum?.d)?.Data || []
      await saveAddedEndumen(dataEndum)

      console.log(nestedStructure, 'nestedStructure', updatedPatients)
      await checkIfMastersExist()
      await saveOfflineData(nestedStructure)

      setAppointmentProgress(100)
      // setFilteredPatientData(updatedPatients)

      //  setIsRefreshLoad(false)
      // toast.success('All appointments data synced successfully', toastConfig);
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      //  setIsRefreshLoad(false)
    }
  }

  const checkUploadPatient = async () => {
    const getProviderDetailsData = await getProviderDetails()
    const data = await getOfflineData()
    if (!data) {
      return true
    }
    const DBData = data[getProviderDetailsData?.ID] || []

    const signedPatients = Object.values(DBData)?.filter((item) => item?.newlyAddedData?.currentNote?.status === 'Signed' && !item?.isUploaded)
    let patientData = signedPatients.map((item) => item?.patientData)
    console.log(DBData, signedPatients, patientData, 'maseter data')
    if (Array.isArray(patientData)) {
      //  const tomorrow = new Date();
      //  tomorrow.setDate(tomorrow.getDate() + 1);
      //  const formattedTmrw = tomorrow.toLocaleDateString('en-US');
      const today = new Date().toLocaleDateString('en-US')

      patientData = patientData.filter((item) => {
        const startTime = item?.appointmentData?.StartTime

        if (!startTime) return false

        const appointmentDate = new Date(startTime).toLocaleDateString('en-US')

        return appointmentDate === today
      })
    }
    console.log('signed data ', signedPatients)
    if (patientData.length > 0) {
      setShowIsRefresh(false)
      return false
    } else {
      return true
    }
  }

  const GetPatientTreatmentsNotes = async () => {
    const isShowRefresh = await checkUploadPatient()
    if (!isShowRefresh) {
      return toast.error('Please upload all the signed patients before downloading.', toastConfig)
    }
    console.log('GetPatientTreatmentsNotes call')
    setAppointmentProgress(0)
    setIsRefreshLoad(true)

    let latesDataAppointment = await getLatestDataPatientDataFn()

    const patientData = latesDataAppointment?.schedulePatient
    const appointment = latesDataAppointment?.appointments

    console.log('appointment data--------->', patientData, appointment)

    if (!patientData || !appointment) return

    try {
      let updatedPatients = await Promise.all(
        appointment.map(async (appt) => {
          const patient = patientData.find((p) => p.PatientID === appt?.data?.PatientID)
          if (!patient) return null

          let status = patient.noteStatus || 'Not Created'
          let flag = 'false'

          if (!appt?.data?.NoteID) {
            return
          }

          let parsedData = []
          try {
            const dataResponse = await PatientNoteDataCRUD('GET', patient.PatientID)
            parsedData = JSON.parse(dataResponse?.d)?.Data || []
            if (parsedData.length > 0) {
              const lastNote = parsedData[parsedData.length - 1]
              status = lastNote?.status || status
              flag = lastNote?.flag || 'false'
            }
          } catch (err) {
            console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
          }

          const scheduleStatus = appt?.data?.Status
          const scheduleBy = appt?.data?.ScheduleBy
          const type = appt?.data?.Type
          const isInFacility = appt?.data?.isInFacility
          const priorAuth = appt?.data?.otherDetails?.priorAuth?.isRequired
          const noteSeen = appt?.data?.patientSeen
          let priorAuthTime = 0

          if (priorAuth) {
            priorAuthTime = parseInt(appt?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
          }

          const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)

          const isScheduledOrRescheduled = (scheduleStatus === 'Scheduled' && noteSeen !== false) || (scheduleStatus === 'Rescheduled' && noteSeen !== false)

          if (!(isScheduledOrRescheduled && isManualOrFollowUp)) return null

          const providerName = appt?.current?.Provider?.label
          const scheduleDate = appt?.data?.StartTime?.split(' ')[0]

          const isProviderAppointment = providerName === loggedUserProvider?.Name
          if (!isProviderAppointment) return null
          console.log(appt?.data, 'appt?.data')

          return {
            ...patient,
            patientData: patient,
            noteStatus: status,
            noteFlag: flag,
            appointmentData: appt?.data,
            allNotes: parsedData,
            appointmentScheduleDate: scheduleDate,
            appointmentID: appt?.data?.AppointmentID,
            AddedByApp: appt?.data?.AddedByApp ? true : false,
            patientTerm: appt?.data?.term || '',
            facilityParentCompany: getPatientFacilityParentCompany({ ...patient, ...appt }, facilities),
            ...(typeof appt?.data?.patientSeen === 'boolean' && {
              patientSeen: appt.data.patientSeen,
              notSeenReason: appt.data.notSeenReason,
            }),
          }
        }),
      )

      updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft'))
      console.log('updatedPatients--->', updatedPatients)
      // setFilteredPatientData(updatedPatients)

      // localStorage.setItem('patientTodaysTreatmentsNotes', JSON.stringify(updatedPatients))
      const allAppointmentData = await PatientAppointmentDetails('GET', '', '', '', '')
      const allAppointmentDetails = await getAllAppointmentsDetails('GET')
      let AllPatientData = await SavePatients('GetAll', '', '', '')
      const AllPatient = JSON.parse(AllPatientData.d).Data
      const callCenter = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
      let dataCallCenter = JSON.parse(callCenter?.d)

      // const isShowRefresh = await checkUploadPatient()s
      console.log('is show refresh data need to show ', isShowRefresh, allAppointmentDetails)

      if (isShowRefresh) {
        console.log('toadys appointment data ', updatedPatients)
        await saveAllTodaysAppointment(JSON.stringify(updatedPatients))
        await GetAppointmentsAllDataInDb(updatedPatients)
        setFilteredPatientData(updatedPatients)
      } else {
        toast.error('Please upload all the signed patients before downloading.', toastConfig)
      }

      await saveAllAppointmentData(allAppointmentData)
      await saveAllAppointmentDetails(allAppointmentDetails)
      await savePatientDetails(AllPatient)
      await saveCallCenterQuestions(dataCallCenter)
      // await GetAppointmentsAllDataInDb()
      setAppointmentProgress(100)
      setIsPatientListUpdate(false)
      setIsRefreshLoad(false)
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      setIsRefreshLoad(false)
      // toast.error('Error in patient treatment', toastConfig)
    }
  }

  const [downloadPatientName, setDownloadPatientName] = useState('')

  const GetPatientTreatmentsNotesForParticularPatient = async (patientIDToFetchDownload) => {
    if (!patientIDToFetchDownload) {
      toast.error('No Patient ID Found.', toastConfig)
      return
    }
    const isShowRefresh = await checkUploadPatient()
    if (!isShowRefresh) {
      return toast.error('Please upload all the signed patients before downloading.', toastConfig)
    }
    console.log('GetPatientTreatmentsNotes call')
    // setAppointmentProgress(0)
    //  setIsRefreshLoadForParticulatPatient(true)

    let latesDataAppointment = await getLatestDataPatientDataFn()

    const patientData = latesDataAppointment?.schedulePatient.filter((item) => item.PatientID === patientIDToFetchDownload)
    const appointment = latesDataAppointment?.appointments
    setDownloadPatientName(patientData?.[0]?.FirstName + ' ' + patientData?.[0]?.LastName)

    console.log('GetPatientTreatmentsNotes call')
    setAppointmentProgress(0)
    setIsRefreshLoadForParticulatPatient(true)

    console.log('appointment data ', patientData, appointment)
    if (!patientData || !appointment) return

    try {
      let updatedPatients = await Promise.all(
        appointment.map(async (appt) => {
          const patient = patientData.find((p) => p.PatientID === appt?.data?.PatientID)
          if (!patient) return null

          let status = patient.noteStatus || 'Not Created'
          let flag = 'false'

          if (!appt?.data?.NoteID) {
            return
          }

          let parsedData = []
          try {
            const dataResponse = await PatientNoteDataCRUD('GET', patient.PatientID)
            parsedData = JSON.parse(dataResponse?.d)?.Data || []
            if (parsedData.length > 0) {
              const lastNote = parsedData[parsedData.length - 1]
              status = lastNote?.status || status
              flag = lastNote?.flag || 'false'
            }
          } catch (err) {
            console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
          }

          const scheduleStatus = appt?.data?.Status
          const scheduleBy = appt?.data?.ScheduleBy
          const type = appt?.data?.Type
          const isInFacility = appt?.data?.isInFacility
          const priorAuth = appt?.data?.otherDetails?.priorAuth?.isRequired
          const noteSeen = appt?.data?.patientSeen
          let priorAuthTime = 0

          if (priorAuth) {
            priorAuthTime = parseInt(appt?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
          }

          const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)

          const isScheduledOrRescheduled = (scheduleStatus === 'Scheduled' && noteSeen !== false) || (scheduleStatus === 'Rescheduled' && noteSeen !== false)

          if (!(isScheduledOrRescheduled && isManualOrFollowUp)) return null

          const providerName = appt?.current?.Provider?.label
          const scheduleDate = appt?.data?.StartTime?.split(' ')[0]

          const isProviderAppointment = providerName === loggedUserProvider?.Name
          if (!isProviderAppointment) return null
          console.log(appt?.data, 'appt?.data')

          // return {
          //   ...patient,
          //   noteStatus: status,
          //   noteFlag: flag,
          //   appointmentScheduleDate: scheduleDate,
          //   appointmentID: appt?.data?.AppointmentID,
          //   AddedByApp: appt?.data?.AddedByApp ? true : false,
          //   patientTerm: appt?.data?.term || '',
          //   ...(typeof appt?.data?.patientSeen === 'boolean' && {
          //     patientSeen: appt.data.patientSeen,
          //     notSeenReason: appt.data.notSeenReason,
          //   }),
          // }
          return {
            ...patient,
            patientData: patient,
            noteStatus: status,
            noteFlag: flag,
            appointmentData: appt?.data,
            allNotes: parsedData,
            appointmentScheduleDate: scheduleDate,
            appointmentID: appt?.data?.AppointmentID,
            AddedByApp: appt?.data?.AddedByApp ? true : false,
            patientTerm: appt?.data?.term || '',
            ...(typeof appt?.data?.patientSeen === 'boolean' && {
              patientSeen: appt.data.patientSeen,
              notSeenReason: appt.data.notSeenReason,
            }),
          }
        }),
      )

      updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft'))

      console.log(updatedPatients, 'updatedPatients')

      // setFilteredPatientData(updatedPatients)

      // localStorage.setItem('patientTodaysTreatmentsNotes', JSON.stringify(updatedPatients))
      const allAppointmentData = await PatientAppointmentDetails('GET', '', '', '', '')
      const allAppointmentDetails = await getAllAppointmentsDetails('GET')
      // const isShowRefresh = await checkUploadPatient()
      console.log('is show refresh data need to show ', isShowRefresh, allAppointmentDetails)

      if (isShowRefresh) {
        console.log('toadys appointment data ', updatedPatients)
        // await saveAllTodaysAppointment(JSON.stringify(updatedPatients))
        await GetAppointmentsAllDataInDbForParticular(updatedPatients)
        // setFilteredPatientData(updatedPatients)
      } else {
        toast.error('Please upload all the signed patients before downloading.', toastConfig)
      }

      await saveAllAppointmentData(allAppointmentData)
      await saveAllAppointmentDetails(allAppointmentDetails)

      // await GetAppointmentsAllDataInDb()
      setAppointmentProgress(100)
      setIsRefreshLoadForParticulatPatient(false)
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      setIsRefreshLoadForParticulatPatient(false)
      // toast.error('Error in patient treatment', toastConfig)
    }
  }

  console.log('isShowRefresh', isShowRefresh)

  const extractUniqueKeywords = (keywordsArray) => {
    let parsedArray = []

    try {
      parsedArray = typeof keywordsArray === 'string' ? JSON.parse(keywordsArray) : keywordsArray
    } catch (err) {
      console.error('Error parsing keywords:', err)
      parsedArray = []
    }

    if (!Array.isArray(parsedArray)) parsedArray = []

    const allKeywords = parsedArray.flatMap((item) => (item.keyword ? item.keyword.split(',') : [])).map((keyword) => keyword.trim())

    const uniqueKeywords = Array.from(new Set(allKeywords))

    return uniqueKeywords
  }

  const getPatientInternalNotes = async (patientID) => {
    let allData = await InternalNotesCRUD('GET', patientID)
    let history = JSON.parse(allData?.d)
    let sortedNotes = history?.Data?.sort((a, b) => new Date(b.Id) - new Date(a.Id))
    return sortedNotes
  }

  const getHospitalRecord = async (patientID) => {
    let allData = await ModifyPatientHistory('GET', patientID)
    const history = JSON.parse(allData?.d)
    return history
  }

  // const getPatientPhysicalExamination = async (patientID) => {
  //   let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID)
  //   console.log("response patient id ", response , patientID)
  //   const parsedData = JSON.parse(response?.d).Data || []

  //   return parsedData
  // }
  const getPatientPhysicalExamination = async (patientID) => {
    try {
      const response = await PatientPhysicalExaminationData('Get_By_Patient', patientID)

      console.log('response patient id ', response, patientID)

      if (!response || !response.d) {
        console.warn('Physical Examination API returned empty or invalid response', response)
        return []
      }

      let parsed

      try {
        parsed = JSON.parse(response.d)
      } catch (err) {
        console.error('JSON parse failed: raw response = ', response.d)
        return []
      }

      // Some APIs return { Data: [...] } or sometimes Data is undefined
      return parsed?.Data || []
    } catch (err) {
      console.error('Error calling Physical Examination API', err)
      return []
    }
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const getDataPersonalHistoryInNote = async (patientID) => {
    let history = {}

    for (const [key, value] of Object.entries(historyObjectKeysParticular)) {
      let allData = await getPatientPersonalHistory('GET', patientID, value, '')

      const formattedData = JSON.parse(allData?.d)

      history[key] = formattedData?.Data
    }
    return history
  }

  const getPatientAllergy = async (patientID) => {
    let formattedData = await GetPatientAllergiesCRUD('GET', patientID)
    formattedData = JSON.parse(formattedData.d)
    formattedData = formattedData?.Data || []

    return formattedData
  }

  const getPatientVitals = async (patientID) => {
    let allVital = { PatientID: patientID }
    allVital = [allVital]
    let allData
    allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))

    allData = JSON.parse(allData.d) || {}

    return allData?.Data
  }

  const fetchPatientLabs = async (patientID) => {
    try {
      let formattedData
      formattedData = await PatientLabsCRUD('GET', patientID.toString())
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }

      formattedData.sort((a, b) => b.id - a.id)

      return formattedData
    } catch (error) {
      console.log(error)
    }
  }

  const getPatientSuperBill = async (PatientID) => {
    let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', PatientID)
    data = JSON.parse(data?.d)?.Data || []
    return data
  }

  // useEffect(() => {
  //     GetPatientTreatmentsNotes()
  // }, [patientData, loggedUserProvider])

  useEffect(() => {
    const loadNotes = async () => {
      setIsPageLoading(true)

      // const cachedNotesData = localStorage.getItem('patientTodaysTreatmentsNotes')
      let cachedNotesData = await getAllTodaysAppointment()

      if (cachedNotesData && refreshCounter === 0) {
        try {
          let parsedNotes = JSON.parse(cachedNotesData)
          console.log(parsedNotes, 'parsedNotesparsedNotes')
          //  if (Array.isArray(parsedNotes) && parsedNotes.length > 0)

          if (Array.isArray(parsedNotes)) {
            const today = new Date()
            const mm = String(today.getMonth() + 1).padStart(2, '0')
            const dd = String(today.getDate()).padStart(2, '0')
            const yyyy = today.getFullYear()
            const todayStr = `${mm}/${dd}/${yyyy}`

            parsedNotes = parsedNotes.filter((item) => item?.appointmentScheduleDate === todayStr)

            setFilteredPatientData(parsedNotes)
            console.log('Loaded patient treatments notes from localStorage')
          } else {
            console.log('Empty cache array, fetching fresh data...')
            await GetPatientTreatmentsNotes()
          }
        } catch (err) {
          console.warn('Invalid cache data, fetching fresh data...')
          await GetPatientTreatmentsNotes()
        }

        setIsPageLoading(false)
      } else {
        // await GetPatientTreatmentsNotes()
        // setIsPageLoading(false)
      }
    }

    loadNotes()
  }, [patientData, loggedUserProvider, refreshCounter])

  const [groupedUpdatedFilteredPatients, setGroupedUpdatedFilteredPatients] = useState([])
  const [updatedFilteredPatients, setUpdatedFilteredPatients] = useState([])
  useEffect(() => {
    setIsPageLoading(true)

    const allFltered =
      filteredPatientData &&
      filteredPatientData
        .map((patient) => ({
          ...patient,
          facilityParentCompany: getPatientFacilityParentCompany(patient, facilities),
        }))
        .filter((patient) => {
          const selectedFacilityLabels = facilities.filter((facility) => filterData.facility.includes(facility.value)).map((facility) => facility.label)

          const matchesFacility = filterData.facility.length === 0 || selectedFacilityLabels.includes(patient.FacilityName)

          const matchesStatus = filterData.status.length === 0 || filterData.status.includes(patient.Status)

          const matchesSearchValue =
            !filterData.searchValue ||
            patient?.FirstName.toLowerCase().includes(filterData.searchValue.toLowerCase()) ||
            patient?.FacilityName.toLowerCase().includes(filterData.searchValue.toLowerCase()) ||
            patient?.facilityParentCompany?.toLowerCase().includes(filterData.searchValue.toLowerCase()) ||
            patient?.DOB?.toLowerCase().includes(filterData.searchValue.toLowerCase())

          const matchesSchedule = !filterData.scheduleDate || patient?.appointmentScheduleDate?.split?.(' ')?.[0] === filterData.scheduleDate

          const matchesDate = !filterData.date || patient?.DOB === filterData.date

          return matchesFacility && matchesStatus && matchesSearchValue && matchesDate && matchesSchedule
        })

    const groupedByDate = {}

    allFltered.forEach((patient) => {
      const date = patient.appointmentScheduleDate
      const facility = patient.FacilityName

      if (!groupedByDate[date]) {
        groupedByDate[date] = {}
      }

      if (!groupedByDate[date][facility]) {
        groupedByDate[date][facility] = []
      }

      groupedByDate[date][facility].push(patient)
    })
    // const sortedGroupedByDate = Object.fromEntries(Object.entries(groupedByDate).sort(([a], [b]) => new Date(b) - new Date()))
    const sortedGroupedByDate = Object.fromEntries(
      Object.entries(groupedByDate).sort(([a], [b]) => {
        const [am, ad, ay] = a.split('/')
        const [bm, bd, by] = b.split('/')

        const dateA = new Date(`${ay}-${am}-${ad}`)
        const dateB = new Date(`${by}-${bm}-${bd}`)

        return dateB - dateA
      }),
    )

    setGroupedUpdatedFilteredPatients(sortedGroupedByDate)
    setUpdatedFilteredPatients(allFltered)
    setPatientCount(allFltered?.length)
    setPatientInfoCount({
      followUp: allFltered.filter((item) => item?.Status === 'Follow Up').length,
      newPatient: allFltered.filter((item) => item?.Status === 'NewPatient').length,
    })
    setIsPageLoading(false)
  }, [filteredPatientData, filterData, facilities])

  // Patient Appointments
  const [showPatientAppointmentId, setShowPatientAppointmentId] = useState(null)
  const [patientAppointment, setPatientAppointment] = useState([])
  const [activeKey, setActiveKey] = useState(1)
  const GetSelectedPatientAppoint = async () => {
    try {
      const selectedAppointments = appointment.filter((appoint) => appoint?.data?.PatientID === showPatientAppointmentId)
      setPatientAppointment(selectedAppointments)
    } catch (error) {
      console.error('Error fetching patient appointments:', error)
      toast.error('Error fetching patient appointments', toastConfig)
    }
  }

  const handleAddNoteId = async (noteID) => {
    try {
      // setIsPageLoading(true)

      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === patientAppointmentID) {
          return {
            ...item,
            data: {
              ...item.data,
              NoteID: noteID,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()

      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save Note Id', toastConfig)
    } finally {
      // setIsPageLoading(false)
      setPatientAppointment(null)
    }
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const getFacilitiesAppointment = async () => {
    let facilities = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(facilities.d)

    facilities = data.Data
    facilities = facilities.filter((obj) => {
      if (obj.Days && obj.Days != '') {
        return obj
      }
    })
    setLocations(facilities)
  }

  function formatDate(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  const getAllProviderDetails = async (obj) => {
    const provider = {
      ID: obj.ID,
    }
    let providerData = await fetchPatientData('SELECTALL', 'Provider', JSON.stringify(provider))
    let insuranceData = JSON.parse(providerData.d)?.Insurance
    let facilityData = JSON.parse(providerData.d)?.Facility
    // setselectProviderInsurances(insuranceData)
    // setselectProviderFacilities(facilityData)

    obj['Insurances'] = insuranceData
    obj['Facilities'] = facilityData

    return obj
  }

  const getProviders = async () => {
    let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
    let data = JSON.parse(providerData.d)
    providerData = data.Data
    let newProviders = []
    for (let i = 0; i < providerData.length; i++) {
      let c = await getAllProviderDetails(providerData[i])
      newProviders.push(c)
    }

    const daysMap = {}

    // Iterate through the providers array
    newProviders.forEach((provider) => {
      // Iterate through each facility of the provider
      provider.Facilities.forEach((facility) => {
        // Split the Days string into an array of days
        const daysArray = facility.Days.split(',')

        // For each day in the daysArray, add the provider to the corresponding entry in the map
        daysArray.forEach((day) => {
          day = day.trim()
          if (!daysMap[day]) {
            daysMap[day] = []
          }

          // Find if the provider already exists in the day's list
          let providerEntry = daysMap[day].find((p) => p.ID === provider.ID)
          if (!providerEntry) {
            // Add the provider if not already in the list for that day
            providerEntry = {
              ID: provider.ID,
              Name: provider.Name,
              Gender: provider.Gender,
              DOB: provider.DOB,
              Address: provider.Address,
              AddressDetails: provider.AddressDetails,
              Lat: provider.Lat,
              Lng: provider.Lng,
              Insurances: provider.Insurances,
              Facilities: [],
            }
            daysMap[day].push(providerEntry)
          }

          // Add the facility to the provider's list of facilities
          providerEntry.Facilities.push(facility)
        })
      })
    })

    setDaysMap(daysMap)
    return newProviders
  }

  useEffect(() => {
    if (showPatientAppointmentId) {
      GetSelectedPatientAppoint()
    }
  }, [showPatientAppointmentId])

  useEffect(() => {
    getProviders()
    getFacilitiesAppointment()
  }, [])

  // const getIntoNoteLatestHandle = async (patientID, patientData) => {

  //   // if(let appointments = await getAppointmentData())
  //     let cachedNotesData =  await getAllTodaysAppointment()
  //    let parsedNotes = JSON.parse(cachedNotesData)
  //    console.log("todaysAppoinemtall",parsedNotes )
  //   const patientAppointments = parsedNotes.filter((item) => item.current.Patient.value === patientData?.PatientID)

  //   // const patientAppointments = appointment.filter((item) => item.current.Patient.value === patientData?.PatientID)
  //      console.log("appointmentData--->", patientAppointments,appointment,patientID)
  //   if(patientAppointments.length === 0){
  //     toast.error('Some data in the system appears to be incomplete or outdated. Please click Refresh to update and continue.', toastConfig)
  //     return
  //   }

  //     console.log('patientData-->', patientData, patientAppointments, appointment, patientData?.PatientID)
  //   const scheduledAppointment = patientAppointments.find((p) => {
  //     const status = p?.data?.Status
  //     const scheduleBy = p?.data?.ScheduleBy
  //     const type = p?.data?.Type
  //     const isInFacility = p?.data?.isInFacility
  //     const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
  //     let priorAuthTime = 0
  //     if (priorAuth) {
  //       priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
  //     }

  //     // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
  //     const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
  //     const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

  //     return isScheduledOrRescheduled && isManualOrFollowUp
  //   })
  //   // const dataResponse = await PatientNoteDataCRUD('GET', patientID)
  //   // const parsedData = JSON.parse(dataResponse?.d)?.Data

  //   // fetching from offline data
  //         const offlineData = await getOfflineData()
  //         console.log(offlineData, 'offlineData')
  //         const parsedData = offlineData[loggedUserProvider?.ID][patientID]?.allNotes || []
  //   // const parsedData = offlineData[patientID]?.allNotes || []
  //   console.log(parsedData, offlineData, patientAppointments ,'parsedDataparsedData')
  //   if (parsedData?.length > 0 && patientAppointments?.length > 0) {
  //     // setPatientID(patientData?.PatientID)
  //     localStorage.setItem('setPatientIDLocal', patientData?.PatientID)
  //     // setPatientIDClicked(patientData?.PatientID)
  //     localStorage.setItem('setPatientIDClickedLocal', patientData?.PatientID)
  //     // setRowClicked(patientData)
  //     localStorage.setItem('setRowClickedLocal', JSON.stringify(patientData))
  //     // setPatientModalVisible(true)
  //     localStorage.setItem('setPatientModalVisibleLocal', true)
  //     // setPatientAppointmentID(scheduledAppointment?.data?.AppointmentID)
  //     localStorage.setItem('setPatientAppointmentIDLocal', scheduledAppointment?.data?.AppointmentID)
  //     const latestItem = parsedData[parsedData.length - 1]
  //     console.log(latestItem, 'latestItem')
  //     // setEditDataId(latestItem?.id)
  //     localStorage.setItem('editDataIdLocal', latestItem?.id)
  //     // setDataCallType('edit')
  //     localStorage.setItem('dataCallTypeLocal', 'edit')
  //     // setNoteStatus(parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
  //     localStorage.setItem('noteStatusLocal', parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
  //     // setPatientModalVisible(false)
  //     localStorage.setItem('patientModalVisibleLocal', false)
  //     // setNoteID(parsedData.length - 1)
  //     localStorage.setItem('noteIDLocal', parsedData.length - 1)
  //     // setPatientData(patientData)
  //     localStorage.setItem('patientDataLocal', JSON.stringify(patientData))
  //     noteStructureRef.current = JSON.parse(latestItem?.data)
  //     console.log(JSON.parse(latestItem?.data), 'JSON.parse(latestItem?.data)')
  //     localStorage.setItem('noteStructureRefLocal', JSON.stringify(JSON.parse(latestItem?.data)))
  //     window.open('/home/provider/today-appointment', '_blank', 'noopener,noreferrer')
  //   }
  // }

  const getIntoNoteLatestHandle = async (patientID, patientData) => {
    // if(let appointments = await getAppointmentData())
    let cachedNotesData = await getAllTodaysAppointment()
    let parsedNotes = JSON.parse(cachedNotesData)
    console.log('todaysAppoinemtall', parsedNotes)
    const patientAppointments = parsedNotes.filter((item) => item.appointmentData?.PatientID === patientData?.PatientID)

    // const patientAppointments = appointment.filter((item) => item.current.Patient.value === patientData?.PatientID)
    console.log('appointmentData--->', patientAppointments, appointment, patientID)
    if (patientAppointments.length === 0) {
      toast.error('Some data in the system appears to be incomplete or outdated. Please click Refresh to update and continue.', toastConfig)
      return
    }

    console.log('patientData-->', patientData, patientAppointments, appointment, patientData?.PatientID)
    const scheduledAppointment = patientAppointments.find((p) => {
      const status = p?.data?.Status
      const scheduleBy = p?.data?.ScheduleBy
      const type = p?.data?.Type
      const isInFacility = p?.data?.isInFacility
      const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
      let priorAuthTime = 0
      if (priorAuth) {
        priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
      }

      // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
      const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
      const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

      return isScheduledOrRescheduled && isManualOrFollowUp
    })

    const AppointmentID = patientAppointments[0]?.appointmentID
    console.log('appointmentissssss', AppointmentID)
    // const dataResponse = await PatientNoteDataCRUD('GET', patientID)
    // const parsedData = JSON.parse(dataResponse?.d)?.Data

    // fetching from offline data
    const offlineData = await getOfflineData()
    console.log(offlineData, 'offlineData')
    const parsedData = offlineData[loggedUserProvider?.ID][patientID]?.allNotes || []
    // const parsedData = offlineData[patientID]?.allNotes || []
    console.log(parsedData, offlineData, patientAppointments, 'parsedDataparsedData')
    if (parsedData?.length > 0 && patientAppointments?.length > 0) {
      // setPatientID(patientData?.PatientID)
      localStorage.setItem('setPatientIDLocal', patientData?.PatientID)
      // setPatientIDClicked(patientData?.PatientID)
      localStorage.setItem('setPatientIDClickedLocal', patientData?.PatientID)
      // setRowClicked(patientData)
      localStorage.setItem('setRowClickedLocal', JSON.stringify(patientData))
      // setPatientModalVisible(true)
      localStorage.setItem('setPatientModalVisibleLocal', true)
      // setPatientAppointmentID(scheduledAppointment?.data?.AppointmentID)
      localStorage.setItem('setPatientAppointmentIDLocal', AppointmentID)
      const latestItem = parsedData[parsedData.length - 1]
      console.log(latestItem, 'latestItem')
      // setEditDataId(latestItem?.id)
      localStorage.setItem('editDataIdLocal', latestItem?.id)
      // setDataCallType('edit')
      localStorage.setItem('dataCallTypeLocal', 'edit')
      // setNoteStatus(parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
      localStorage.setItem('noteStatusLocal', parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
      // setPatientModalVisible(false)
      localStorage.setItem('patientModalVisibleLocal', false)
      // setNoteID(parsedData.length - 1)
      localStorage.setItem('noteIDLocal', parsedData.length - 1)
      // setPatientData(patientData)
      localStorage.setItem('patientDataLocal', JSON.stringify(patientData))
      noteStructureRef.current = JSON.parse(latestItem?.data)
      console.log(JSON.parse(latestItem?.data), 'JSON.parse(latestItem?.data)')
      localStorage.setItem('noteStructureRefLocal', JSON.stringify(JSON.parse(latestItem?.data)))
      window.open('/home/provider/today-appointment', '_blank', 'noopener,noreferrer')
    }
  }

  const safeParser = (data) => {
    try {
      return JSON.parse(data)
    } catch (e) {
      return data
    }
  }

  useEffect(() => {
    const setPatientIDLocal = safeParser(localStorage.getItem('setPatientIDLocal'))
    const setPatientIDClickedLocal = safeParser(localStorage.getItem('setPatientIDClickedLocal'))
    const setRowClickedLocal = safeParser(localStorage.getItem('setRowClickedLocal'))
    const setPatientModalVisibleLocal = safeParser(localStorage.getItem('setPatientModalVisibleLocal'))
    const setPatientAppointmentIDLocal = safeParser(localStorage.getItem('setPatientAppointmentIDLocal'))
    const editDataIdLocal = safeParser(localStorage.getItem('editDataIdLocal'))
    const dataCallTypeLocal = safeParser(localStorage.getItem('dataCallTypeLocal'))
    const noteStatusLocal = safeParser(localStorage.getItem('noteStatusLocal'))
    const patientModalVisibleLocal = safeParser(localStorage.getItem('patientModalVisibleLocal'))
    const noteIDLocal = safeParser(localStorage.getItem('noteIDLocal'))
    const patientDataLocal = safeParser(localStorage.getItem('patientDataLocal'))
    const noteStructureRefLocal = safeParser(localStorage.getItem('noteStructureRefLocal'))

    console.log(
      'all local storage data==> today appointment',
      setPatientIDLocal,
      setPatientIDClickedLocal,
      setRowClickedLocal,
      setPatientModalVisibleLocal,
      setPatientAppointmentIDLocal,
      editDataIdLocal,
      dataCallTypeLocal,
      noteStatusLocal,
      patientModalVisibleLocal,
      noteIDLocal,
      patientDataLocal,
      noteStructureRefLocal,
    )

    // if (setPatientIDLocal && setPatientIDLocal !== -1) {
    //     setPatientID(setPatientIDLocal)
    // }
    // if (setPatientIDClickedLocal && setPatientIDClickedLocal !== -1) {
    //     setPatientIDClicked(setPatientIDClickedLocal)
    // }
    // if (setRowClickedLocal !== null && setRowClickedLocal !== undefined) {
    //     setRowClicked(setRowClickedLocal)
    //     setPatientData(setRowClickedLocal)
    // }
    // if (setPatientModalVisibleLocal) {
    //     //   set(setPatientModalVisibleLocal)
    // }
    // if (setPatientAppointmentIDLocal) {
    //     setPatientAppointmentID(setPatientAppointmentIDLocal)
    // }
    if (editDataIdLocal) {
      setEditDataId(editDataIdLocal)
    }
    // if (dataCallTypeLocal) {
    //     setDataCallType(dataCallTypeLocal)
    // }
    // if (noteStatusLocal) {
    //     setNoteStatus(noteStatusLocal)
    // }
    // if (patientModalVisibleLocal) {
    //     // setPatientModalVisible(patientModalVisibleLocal)
    // }
    // if (noteIDLocal) {
    //     setNoteID(noteIDLocal)
    // }
    // if (patientDataLocal) {
    //     setPatientData(patientDataLocal)
    // }
    // if(noteStructureRefLocal !==  null && noteStructureRefLocal !== undefined){
    //     noteStructureRef.current = noteStructureRefLocal
    // }
  }, [])

  //   const getIntoNoteLatestHandle = async (patientID, patientData) => {
  //     const patientAppointments = appointment.filter((item) => item.current.Patient.value === patientData?.PatientID)

  //     const scheduledAppointment = patientAppointments.find((p) => {
  //       const status = p?.data?.Status
  //       const scheduleBy = p?.data?.ScheduleBy
  //       const type = p?.data?.Type
  //       const isInFacility = p?.data?.isInFacility
  //       const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
  //       let priorAuthTime = 0
  //       if (priorAuth) {
  //         priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
  //       }

  //       // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
  //       const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
  //       const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

  //       return isScheduledOrRescheduled && isManualOrFollowUp
  //     })
  //     const dataResponse = await PatientNoteDataCRUD('GET', patientID)
  //     const parsedData = JSON.parse(dataResponse?.d)?.Data
  //     if (parsedData?.length > 0 && patientAppointments?.length > 0) {
  //       // setPatientID(patientData?.PatientID)
  //       localStorage.setItem("setPatientIDStrg", patientData?.PatientID)
  //       // setPatientIDClicked(patientData?.PatientID)
  //       localStorage.setItem("setPatientIDClickedStrg", patientData?.PatientID)
  //       // setRowClicked(patientData)
  //       localStorage.setItem("setRowClickedStrg", JSON.stringify(patientData))
  //       // setPatientModalVisible(true)
  //       localStorage.setItem("setPatientModalVisibleStrg", true)
  //       // setPatientAppointmentID(scheduledAppointment?.data?.AppointmentID)
  //       localStorage.setItem('setPatientAppointmentIDStrg', scheduledAppointment?.data?.AppointmentID)
  //       const latestItem = parsedData[parsedData.length - 1]

  //       // setEditDataId(latestItem?.id)
  //       localStorage.setItem('editDataIdStrg', latestItem?.id)
  //       // setDataCallType('edit')
  //       localStorage.setItem('dataCallTypeStrg', 'edit')
  //       // setNoteStatus(parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
  //       localStorage.setItem('noteStatusStrg', parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
  //       // setPatientModalVisible(false)
  //       localStorage.setItem('patientModalVisibleStrg', false)
  //       // setNoteID(parsedData.length - 1)
  //       localStorage.setItem('noteIDStrg', parsedData.length - 1)
  //       // setPatientData(patientData)
  //       localStorage.setItem('patientDataStrg', JSON.stringify(patientData))
  //       // noteStructureRef.current = JSON.parse(latestItem?.data)
  //       console.log(JSON.parse(latestItem?.data),'JSON.parse(latestItem?.data)')
  //       // return
  //       localStorage.setItem('noteStructureRefStrg', JSON.stringify(JSON.parse(latestItem?.data)))
  //     await window.open("/home/provider/today-appointment", "_blank","noopener,noreferrer");
  //     }
  //   }

  // const safeParse = (value) => {
  //   try {
  //     return JSON.parse(value);
  //   } catch {
  //     return value; // fallback to raw string if not valid JSON
  //   }
  // };
  //   useEffect(()=>{

  //     const setPatientIDStrg = JSON.parse(localStorage.getItem('setPatientIDStrg'))
  //     const setPatientIDClickedStrg = JSON.parse(localStorage.getItem('setPatientIDClickedStrg'))
  //     const setRowClickedStrg = JSON.parse(localStorage.getItem('setRowClickedStrg'))
  //     const setPatientModalVisibleStrg = safeParse(localStorage.getItem('setPatientModalVisibleStrg'))
  //     const setPatientAppointmentIDStrg = safeParse(localStorage.getItem('setPatientAppointmentIDStrg'))
  //     const editDataIdStrg = safeParse(localStorage.getItem('editDataIdStrg'))
  //     const dataCallTypeStrg = localStorage.getItem('dataCallTypeStrg') && safeParse(localStorage.getItem('dataCallTypeStrg'))
  //     const noteStatusStrg = safeParse(localStorage.getItem('noteStatusStrg'))
  //     const patientModalVisibleStrg = safeParse(localStorage.getItem('patientModalVisibleStrg'))
  //     const noteIDStrg = safeParse(localStorage.getItem('noteIDStrg'))
  //     const patientDataStrg = JSON.parse(localStorage.getItem('patientDataStrg'))
  //     const noteStructureRefStrg = JSON.parse(localStorage.getItem('noteStructureRefStrg'))

  //     console.log('allvalues',setPatientIDStrg,setPatientIDClickedStrg,setRowClickedStrg,setPatientModalVisibleStrg,setPatientAppointmentIDStrg,editDataIdStrg,dataCallTypeStrg,noteStatusStrg,patientModalVisibleStrg,noteIDStrg,patientDataStrg,noteStructureRefStrg)

  //     if(setPatientIDStrg){
  //       setPatientID(setPatientIDStrg)
  //     }

  //     if(setPatientIDClickedStrg){
  //       setPatientIDClicked(setPatientIDClickedStrg)
  //     }

  //     if(setRowClickedStrg){
  //       setRowClicked(setRowClickedStrg)
  //     }

  //     if(setPatientModalVisibleStrg !== null && setPatientModalVisibleStrg !== undefined){
  //       setPatientModalVisible(setPatientModalVisibleStrg)
  //     }

  //     if(setPatientAppointmentIDStrg){
  //       setPatientAppointmentID(setPatientAppointmentIDStrg)
  //     }

  //     if(editDataIdStrg){
  //       setEditDataId(editDataIdStrg)
  //     }

  //     if(dataCallTypeStrg){
  //       setDataCallType(dataCallTypeStrg)
  //     }

  //     if(noteStatusStrg){
  //       setNoteStatus(noteStatusStrg)
  //     }

  //     if(patientModalVisibleStrg  !== null && patientModalVisibleStrg !== undefined){
  //       setPatientModalVisible(patientModalVisibleStrg)
  //     }

  // if (noteIDStrg !== null && noteIDStrg !== undefined) {
  //   setNoteID(noteIDStrg);
  // }

  //     if(patientDataStrg){
  //       setPatientData(patientDataStrg)
  //     }

  //     if(noteStructureRefStrg){
  //       noteStructureRef.current = noteStructureRefStrg
  //       closeSidebar()

  //     }

  //     localStorage.removeItem('setPatientIDStrg')
  //     localStorage.removeItem('setPatientIDClickedStrg')
  //     localStorage.removeItem('setRowClickedStrg')
  //     localStorage.removeItem('setPatientModalVisibleStrg')
  //     localStorage.removeItem('setPatientAppointmentIDStrg')
  //     localStorage.removeItem('editDataIdStrg')
  //     localStorage.removeItem('dataCallTypeStrg')
  //     localStorage.removeItem('noteStatusStrg')
  //     localStorage.removeItem('patientModalVisibleStrg')
  //     localStorage.removeItem('noteIDStrg')
  //     localStorage.removeItem('patientDataStrg')
  //     localStorage.removeItem('noteStructureRefStrg')

  //   },[])

  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role

  const patientDataFnForLoader = async (appointments) => {
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      let patient = JSON.parse(patientData.d).Data
      let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))

      return schedulePatient
    } catch (error) {
      console.log(error)
    } finally {
    }
  }

  const GetPatientTreatmentsNotesForLoaderold = async (patientData, appointment) => {
    if (!patientData) return

    try {
      let updatedPatients = await Promise.all(
        patientData.map(async (patient) => {
          let status = patient.noteStatus || 'Not Created' // Default status
          let flag = 'false' // Default flag
          if (!appt?.data?.NoteID) {
            return
          }
          try {
            const dataResponse = await PatientNoteDataCRUD('GET', patient?.PatientID)
            const parsedData = JSON.parse(dataResponse?.d)?.Data
            if (Array.isArray(parsedData) && parsedData.length > 0) {
              status = parsedData[parsedData.length - 1]?.status || status
              flag = parsedData[parsedData.length - 1]?.flag || 'false'
            }
          } catch (err) {
            console.error(`Error fetching notes for   patient ${patient?.PatientID}:`, err)
          }

          const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

          const scheduledAppointment = patientAppointments.find((p) => {
            const status = p?.data?.Status
            const scheduleBy = p?.data?.ScheduleBy
            const type = p?.data?.Type
            const isInFacility = p?.data?.isInFacility
            const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
            const noteSeen = p?.data?.patientSeen
            let priorAuthTime = 0
            if (priorAuth) {
              priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
            }
            const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
            const isScheduledOrRescheduled = (status === 'Scheduled' && noteSeen !== false) || (status === 'Rescheduled' && noteSeen !== false)

            return isScheduledOrRescheduled && isManualOrFollowUp
          })

          if (!scheduledAppointment) return null

          return {
            ...patient,
            noteStatus: status,
            noteFlag: flag,
          }
        }),
      )

      updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag == 'true' && item?.noteStatus == 'Draft'))

      return updatedPatients
    } catch (error) {
      console.error('Error fetching patient orders', error)
      // toast.error('Error in patient treatment', toastConfig);
    }
  }

  const GetPatientTreatmentsNotesForLoader = async (patientData, appointment) => {
    if (!patientData || !appointment) return

    try {
      let updatedPatients = await Promise.all(
        appointment.map(async (appt) => {
          const patient = patientData.find((p) => p.PatientID === appt?.data?.PatientID)
          if (!patient) return null

          let status = patient.noteStatus || 'Not Created'
          let flag = 'false'

          if (!appt?.data?.NoteID) {
            return
          }

          try {
            const dataResponse = await PatientNoteDataCRUD('GET', patient.PatientID)
            const parsedData = JSON.parse(dataResponse?.d)?.Data || []

            if (Array.isArray(parsedData) && parsedData.length > 0) {
              // pick last note
              const lastNote = parsedData[parsedData.length - 1]
              status = lastNote?.status || status
              flag = lastNote?.flag || 'false'
            }
          } catch (err) {
            console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
          }

          const scheduleStatus = appt?.data?.Status
          const scheduleBy = appt?.data?.ScheduleBy
          const type = appt?.data?.Type
          const isInFacility = appt?.data?.isInFacility
          const priorAuth = appt?.data?.otherDetails?.priorAuth?.isRequired
          const noteSeen = appt?.data?.patientSeen
          let priorAuthTime = 0

          if (priorAuth) {
            priorAuthTime = parseInt(appt?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
          }

          const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)

          const isScheduledOrRescheduled = (scheduleStatus === 'Scheduled' && noteSeen !== false) || (scheduleStatus === 'Rescheduled' && noteSeen !== false)

          if (!(isScheduledOrRescheduled && isManualOrFollowUp)) return null

          return {
            ...patient,
            noteStatus: status,
            noteFlag: flag,
          }
        }),
      )

      updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft'))

      const isShowRefresh = await checkUploadPatient()

      console.log('isShowRefresh loader', isShowRefresh)
      if (isShowRefresh) {
        return updatedPatients
      } else {
        return []
      }
      // return updatedPatients
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      // toast.error('Error in patient treatment', toastConfig)
    }
  }

  const [appointmentTestData, setAppointmentTestData] = useState(null)
  const hasFetchedData = useRef(false)

  /// don't remove
  // useEffect(() => {

  //     if (loggedUserProvider?.ID && !hasFetchedData.current) {
  //         const fetchData = async () => {
  //             const data = await getDataforAppointmentTest(loggedUserProvider?.ID)
  //             const patientDataL = await patientDataFnForLoader(data)
  //             const finalData = await GetPatientTreatmentsNotesForLoader(patientDataL, data)
  //             setAppointmentTestData(finalData)
  //             hasFetchedData.current = true
  //         }

  //         fetchData()
  //     }
  // }, [loggedUserProvider?.ID])

  // useEffect(() => {
  //   if (loggedUserProvider?.ID && !hasFetchedData.current) {
  //     const fetchData = async () => {
  //       // const cachedNotesData = localStorage.getItem('patientTodaysTreatmentsNotes')
  //     const cachedNotesData = await getAllTodaysAppointment()
  //       if (cachedNotesData && refreshCounter === 0) {
  //         try {
  //           const parsedNotes = JSON.parse(cachedNotesData)

  //           if (Array.isArray(parsedNotes) && parsedNotes.length > 0) {
  //             setAppointmentTestData(parsedNotes)
  //             console.log('Loaded patient treatments notes from localStorage')
  //           } else {
  //             const data = await getDataforAppointmentTest(loggedUserProvider?.ID)
  //             const patientDataL = await patientDataFnForLoader(data)
  //             const finalData = await GetPatientTreatmentsNotesForLoader(patientDataL, data)
  //              console.log('setAppointmentTestData data', finalData)
  //             setAppointmentTestData(finalData)
  //             hasFetchedData.current = true
  //           }
  //         } catch (err) {
  //           console.warn('Invalid cache data, fetching fresh data...')
  //           const data = await getDataforAppointmentTest(loggedUserProvider?.ID)
  //           const patientDataL = await patientDataFnForLoader(data)
  //           const finalData = await GetPatientTreatmentsNotesForLoader(patientDataL, data)
  //           setAppointmentTestData(finalData)
  //           hasFetchedData.current = true
  //         }
  //       } else {
  //         const data = await getDataforAppointmentTest(loggedUserProvider?.ID)
  //         const patientDataL = await patientDataFnForLoader(data)
  //         const finalData = await GetPatientTreatmentsNotesForLoader(patientDataL, data)
  //         setAppointmentTestData(finalData)
  //         hasFetchedData.current = true
  //       }
  //     }

  //     fetchData()
  //   }
  // }, [loggedUserProvider?.ID])

  const handleAddPatientData = (facility, patients) => {
    setFacility((prev) => ({
      ...prev,
      facility: facility,
    }))
    const userFacilities = facilities.find((item) => item.label === facility)
    setPatinetWithFacilityData(userFacilities)
    setModalVisible(true)
  }

  const GetPatientTreatmentsNoteID = async (patientID) => {
    try {
      let data
      data = await PatientNoteDataCRUD('GET', patientID)
      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data.map((item) => {
          return {
            ...item,
            data: item.data ? JSON.parse(item?.data) : {},
          }
        })

        return data
      }
    } catch (error) {
      toast.error('error in patient treatment', toastConfig)
    } finally {
    }
  }

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    console.log(allPatientHpiData, 'allPatientHpiData')
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
    return latest || null
  }

  const handleAddMedicationData = async (patientID, noteID) => {
    let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
    let allData = JSON.parse(data?.d)

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
    console.log(result, 'result[patientID]')
    if (!result) {
      console.log(patientData?.Status, noteID, 'result not found')
      // if (patientData?.Status === 'Follow Up' && noteID === 0) {
      if (true) {
        console.log('running the data here')
        const finalHpiStructure = {
          [patientID]: {
            [noteID]: {
              HPI: {},
              medicationRemarksForSubjective: '',
              data: 'Greater than 50% of the total time was spent on coordinating care, reviewing labs, imaging, and speaking with nursing and ancillary staff.',
            },
          },
        }
        console.log(finalHpiStructure, 'insert the data here')
        let data = await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
      }
    } else {
      console.log('insert the data here already')
    }
  }

  // const handleSubmitNote = async (patientId) => {
  //   if (!patientId) {
  //     console.error('patine id not found')
  //     return null
  //   }

  //   const updatedTreatmentShellData = {
  //     assessment: [],
  //     imagingDetails: [],
  //     labDetails: [],
  //     medicationDetails: [],
  //     poa: [],
  //     riskFactors: [],
  //     plans: [],
  //     patientDifferentialDiagnosis: {},
  //     incident: {},
  //     reviewOfSystem: {},
  //     alertData: [],
  //     MobilityAssessment: {},
  //     selfCareAssessment: {},
  //     metadata: {},
  //     incidentRemark: '',
  //     BIMSScore: [],
  //     MorseScore: [],
  //     noteID: 0,
  //     historyOfDiagnosis: [],
  //   }

  //   handleAddMedicationData(patientId, 0)

  //   const formattedJson = JSON.stringify(updatedTreatmentShellData)
  //   const result = await PatientNoteDataCRUD('INSERT', patientId.toString(), '', formattedJson, getFormattedDate().toString(), 'Submitted', 'true')
  //   let noteIdForAppointment

  //   noteIdForAppointment = await GetPatientTreatmentsNoteID(patientId)
  //   return noteIdForAppointment && noteIdForAppointment?.length > 0 && noteIdForAppointment[0]?.id
  // }

  const handleSubmitNote = async (patientId) => {
    if (!patientId) {
      console.error('patine id not found')
      return null
    }

    const updatedTreatmentShellData = {
      assessment: [],
      imagingDetails: [],
      labDetails: [],
      medicationDetails: [],
      poa: [],
      riskFactors: [],
      plans: [],
      patientDifferentialDiagnosis: {},
      incident: {},
      reviewOfSystem: {},
      alertData: [],
      MobilityAssessment: {},
      selfCareAssessment: {},
      metadata: {},
      incidentRemark: '',
      BIMSScore: [],
      MorseScore: [],
      noteID: 0,
      historyOfDiagnosis: [],
    }

    handleAddMedicationData(patientId, 0)

    const formattedJson = JSON.stringify(updatedTreatmentShellData)

    const tempId = Math.floor(100 + Math.random() * 900)
    const noteData = {
      mode: 'insert',
      patientID: patientId.toString(),
      data: formattedJson,
      date: getFormattedDate().toString(),
      status: 'Submitted',
      flag: 'true',
      id: tempId,
    }
    return noteData
  }

  const handleSubmit = async (updateData, apiCallType = 'INSERT') => {
    try {
      setIsPageLoading(true)

      const groupedData = []

      updateData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      const date = formatDateFilter(new Date())
      if (date && loggedUserProvider?.ID) {
        if (apiCallType == 'UPDATE') {
          const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)
          await PatientAppointmentDetails('UPDATE', ID, date, loggedUserProvider?.ID, JSON.stringify(groupedData))
        } else if (apiCallType == 'INSERT') {
          await PatientAppointmentDetails('INSERT', '', date, loggedUserProvider?.ID, JSON.stringify(groupedData))
        }
      } else {
        console.error('an error occured while submiting data')
      }

      //  toast.success('Created Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
      console.error('Failed to save ', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleSchdulePatinet = async (noteId, patientData) => {
    try {
      let organizeDate = formatDate(new Date())
      let data = {
        AppointmentName: `${patientData.FirstName} ${patientData.LastName}`,
        StartTime: organizeDate,
        EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
        PatientID: patientData.PatientID,
        StartTimezone: null,
        EndTimezone: null,
        Status: 'Scheduled',
        Notes: '',
        RoomNumber: patientData?.Room,
        VisitReason: 'N/P (New Patient)',
        Insurance: {},
        isInFacility: true,
        otherDetails: {},
        Facility: patinetWithFacilityData.label || '',
        ProviderName: loggedUserProvider?.Name || '',
        AppointmentID: Date.now(),
        ScheduleBy: 'manuel',
        // PatientStatus: filtered.length > 0 ? 'Follow Up' : item?.Status || 'NewPatient'
        Type: 'New',
        CreatedDate: new Date(),
        patientSeen: true,
        notSeenReason: '',
        customReason: '',
        AddedByApp: true,
        NoteID: noteId,
        term: verifyFormData?.term !== '' ? verifyFormData?.term : 'Short Term',
        // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
      }

      console.log('patineTempAppointment', data)
      let details = {
        data,
        current: {
          Patient: { value: patientData.PatientID, label: `${patientData.FirstName} ${patientData.LastName}` },
          Facility: patinetWithFacilityData,
          Provider: { value: loggedUserProvider?.ID, label: loggedUserProvider?.Name },
        },
      }

      if (details) {
        const date = formatDateFilter(new Date())
        const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)
        const type = latestData.length > 0 ? 'UPDATE' : 'INSERT'

        const combinedAppointments = [...latestData, details]

        console.log('combinedAppointments', combinedAppointments)

        setAppointment(combinedAppointments)

        // handleSubmit(combinedAppointments, type)
        return details
      }

      //  setSelectedPatients([])
    } catch (error) {
      console.log('error while scheduling', error)
    }
  }

  // const handlePatientSubmit = async () => {
  //   setCreatingPatientLoader(true)
  //   try {
  //     let a = {
  //       FacilityID: patinetWithFacilityData?.value.toString() || '',
  //       FacilityName: patinetWithFacilityData?.label.toString() || '',
  //       Room: facility?.roomNumber || -1,
  //     }

  //     let savePatientInfo

  //     const today = new Date()
  //     const mm = String(today.getMonth() + 1).padStart(2, '0')
  //     const dd = String(today.getDate()).padStart(2, '0')
  //     const yyyy = today.getFullYear()
  //     const formattedDate = `${mm}/${dd}/${yyyy}`
  //     const PatientDummyData = -1

  //      let resultData = await SavePatients('Insert', JSON.stringify({ ...childformData, createdDate: formattedDate }), JSON.stringify(a), '', PatientDummyData, '{}')
  //     toast.success('Patient Added Successfully', toastConfig)

  //     resultData = JSON.parse(resultData.d)

  //     const newPatientData = resultData?.Data[0]
  //     const finalPatientID = resultData.Data[0].PatientID

  //     if (finalPatientID) {
  //       const noteIdForAppointment = await handleSubmitNote(finalPatientID)

  //       if (noteIdForAppointment) {
  //         await handleSchdulePatinet(noteIdForAppointment, newPatientData)
  //       }
  //     }
  //     await getAppointmentData()
  //     // await GetPatientTreatmentsNotes()
  //     await patientDataFn()
  //     resetStates()
  //     setPatientID('')
  //     setCreatingPatientLoader(false)
  //   } catch (error) {
  //     setCreatingPatientLoader(false)
  //     toast.error('Failed to save patient data. Please try again.', toastConfig)
  //   }
  // }

  const GetAppointmentsAllDataInDbForAddonPatient = async (updatedPatients, patientData) => {
    if (!patientData || !appointment) return
    console.log('appointment data', appointment)
    try {
      const nestedStructure = {}
      const imagingTypeList = (await getImagingDetailsAllMaster()) || []

      console.log(imagingTypeList, 'imagingTypeList', updatedPatients)

      await Promise.all(
        updatedPatients.map(async (patient) => {
          const providerId = loggedUserProvider?.ID
          if (!nestedStructure[providerId]) nestedStructure[providerId] = {}

          const lastNote = patient?.allNotes?.[patient?.allNotes.length - 1] || {}
          let parsedNoteData = {}

          // imaginggs fetching and formatting
          let imagings = []
          let formattedData = await PatientImagingsCRUD('GET', patient?.PatientID?.toString())

          if (formattedData) {
            formattedData = JSON.parse(formattedData.d)
            formattedData = formattedData.Data.map((item) => {
              const parsedData = JSON.parse(item.data)
              const matchingType = parsedData && imagingTypeList.find((type) => type.Name.toString() === parsedData.name.toString())
              console.log(matchingType, 'matchingType for imaging', parsedData.name)
              return {
                ...item,
                data: {
                  ...parsedData,
                  keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
                },
              }
            }).sort((a, b) => new Date(b?.date) - new Date(a?.date))
            imagings = formattedData
          }

          try {
            parsedNoteData = typeof lastNote?.data === 'string' ? JSON.parse(lastNote.data) : lastNote?.data || {}
          } catch (err) {
            parsedNoteData = {}
          }

          console.log(imagings, 'imagings for patient', patient.PatientID)

          // medication fetching and formatting
          let formattedDataMeds
          const masterMedications = (await getMedicationMasterData()) || []
          console.log(masterMedications, 'masterMedications')
          const responseMed = await PatientMedications('GET', patient?.PatientID?.toString())

          formattedDataMeds = JSON.parse(responseMed?.d)
          formattedDataMeds = formattedDataMeds?.Data

          const masterMedsNames = masterMedications.map((med) => med.Data?.name?.toLowerCase())

          if (formattedDataMeds) {
            formattedDataMeds = formattedDataMeds.map((item) => {
              let parsedData = []
              try {
                parsedData = item.data ? JSON.parse(item.data) : []
              } catch (e) {
                console.error('Error parsing item.data:', e, item.data)
              }

              const updatedData = Array.isArray(parsedData)
                ? parsedData.map((med) => ({
                  ...med,
                  inMaster: masterMedsNames.includes(med?.name?.toLowerCase()),
                }))
                : []
              updatedData.sort((a, b) => (a.inMaster === b.inMaster ? 0 : a.inMaster ? -1 : 1))

              return {
                ...item,
                data: updatedData,
              }
            })
          }

          formattedDataMeds.sort((a, b) => new Date(b?.date) - new Date(a?.date))
          console.log(formattedDataMeds, 'formattedDataMeds for patient medications')

          // Orders fetching and formatting
          let dataOrders = await PatientOrdersCRUD('Get', '', patient?.PatientID)

          dataOrders = JSON.parse(dataOrders?.d).Data || []
          console.log(dataOrders, 'dataOrders for patientname', patient?.FirstName)
          const parsedOrders = dataOrders?.map((order) => {
            let parsedDataMeds = []
            try {
              parsedDataMeds = order.medication ? JSON.parse(order.medication) : []
            } catch (e) {
              console.error('Error parsing order.data:', e, order.data)
            }
            return {
              id: order.id,
              date: order.date,
              medication: parsedDataMeds,
            }
          })
          // .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

          let tempAnswersGetPatientDiagnosisDetails = await GetPatientDiagnosisDetails(patient?.PatientID)

          console.log('Past Orders:', noteID, parseInt(noteID), parsedOrders)
          const intenalNotes = await getPatientInternalNotes(patient.PatientID)

          const hospitalRecords = await getHospitalRecord(patient.PatientID)

          const patientHistories = await getDataPersonalHistoryInNote(patient.PatientID)

          const patientAllergy = await getPatientAllergy(patient.PatientID)

          const patientVitals = await getPatientVitals(patient.PatientID)

          const labData = await fetchPatientLabs(patient.PatientID)

          const PEPatientData = await getPatientPhysicalExamination(patient.PatientID)

          const patientSuperBill = await getPatientSuperBill(patient.PatientID)

          const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous']
          const formattedDataReport = {
            // [oneofsection] : data
          }

          for (const sections of threeSections) {
            let formattedData
            formattedData = await PatientReportCRUD('GET', patient?.PatientID?.toString(), '', sections.toString())

            if (formattedData) {
              formattedData = JSON.parse(formattedData.d)?.Data
              formattedData = formattedData.map((item) => {
                return {
                  ...item,
                  data: JSON.parse(item.data),
                }
              })
            }
            for (const item of formattedData || []) {
              for (const file of item.data) {
                if (file?.url) {
                  try {
                    const response = await fetch(file.url)
                    const blob = await response.blob()

                    const blobUrl = URL.createObjectURL(blob)

                    file.blobUrl = blobUrl

                    console.log(`Added blobUrl for ${file.id || item.id}:`, blobUrl)
                  } catch (error) {
                    console.error('Failed to fetch or convert image to blob:', error)
                  }
                }
              }
            }

            formattedDataReport[sections] = formattedData || []
          }

          let diagnosisDataIndexed = await ModifyPatientMap('GETALL', patient?.PatientID, '')
          let tempData = JSON.parse(diagnosisDataIndexed.d)?.Data

          diagnosisDataIndexed = tempData.filter((obj) => {
            if (patient?.PatientID == obj.PatientID) {
              return obj
            }
          })

          console.log(diagnosisDataIndexed, patient, 'diagnosisDataIndexed')

          nestedStructure[providerId][patient.PatientID] = {
            details: patient.patientData,
            currentNote: {
              ...lastNote,
              data: parsedNoteData,
            },
            tempAnswersGetPatientDiagnosisDetails,
            appointmentData: patient.appointmentData,
            appointmentId: patient.appointmentID,
            totalNotes: 0,
            allImaging: imagings || [],
            ordersData: parsedOrders || [],
            allMedications: formattedDataMeds || [],
            interNote: intenalNotes || [],
            isFirstNote: true,
            allNotes: patient?.allNotes || [],
            isDetailsSyncedWithServer: false,
            hospitalRecords: hospitalRecords || [],
            patientHistories: patientHistories || {},
            patientAllergy: patientAllergy,
            patientVitals: patientVitals,
            patientLabData: labData,
            PEPatientData: PEPatientData,
            reportData: formattedDataReport,
            patientSuperBill: patientSuperBill,
            diagnosisDataModifyMap:
              diagnosisDataIndexed?.length > 0
                ? diagnosisDataIndexed
                : [
                  {
                    PatientID: patient?.PatientID,
                    Room: patient?.Room,
                    FacilityName: patient?.FacilityName,
                    Diagnosis: patient?.Diagnosis || '',
                    Id: patient?.PatientID,
                  },
                ],
            patientData: patient,
            newPatientDiagnosis: [],
            finalDiagnosis: '',
            isDiagnosisAdded: false,
          }
        }),
      )

      let dataHPiPatient = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')

      dataHPiPatient = JSON.parse(dataHPiPatient?.d)
      await savePatientHpi(dataHPiPatient)

      let dataEndum = await SaveExtra('Get_By_Type', 'Addendum', '', '')

      dataEndum = JSON.parse(dataEndum?.d)?.Data || []
      await saveAddedEndumen(dataEndum)

      console.log(nestedStructure, 'nestedStructure', updatedPatients)
      await checkIfMastersExist()
      await saveOfflineData(nestedStructure)

      // setFilteredPatientData(updatedPatients)

      //  setIsRefreshLoad(false)
      // toast.success('All appointments data synced successfully', toastConfig);
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      //  setIsRefreshLoad(false)
    }
  }

  const [formValidationErrors, setFormValidationErrors] = useState({})

  const validatePatientForm = () => {
    let isValid = true
    let errors = {}

    if (!childformData.FirstName?.trim()) {
      errors.FirstName = 'First Name is required'
      isValid = false
    }

    if (!childformData.LastName?.trim()) {
      errors.LastName = 'Last Name is required'
      isValid = false
    }

    if (!childformData.DOB) {
      errors.DOB = 'Date of Birth is required'
      isValid = false
    }

    if (!facility.roomNumber?.trim()) {
      errors.roomNumber = 'Room Number is Required'
      isValid = false
    }

    setFormValidationErrors(errors) // Set in parent state
    return isValid
  }

  const updatePatientMasterData = async (patientEditData) => {
    const patientData = await getPatientDetails()

    console.log('patientEditData', patientData)
    const updatedPatients = [...patientData, patientEditData]

    await savePatientDetails(updatedPatients)

    console.log('Updated Patient', updatedPatients)
  }

  const handlePatientSubmit = async () => {
    const isValid = validatePatientForm()
    if (!isValid) {
      toast.error('Please fill all required fields', toastConfig)
      return
    }
    setCreatingPatientLoader(true)

    const getAllPatientData = (await getNewPatientData()) || []
    console.log('getAllPatientData', getAllPatientData)
    try {
      let a = {
        FacilityID: patinetWithFacilityData?.value.toString() || '',
        FacilityName: patinetWithFacilityData?.label.toString() || '',
        Room: facility?.roomNumber || -1,
      }

      let savePatientInfo

      const today = new Date()
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const dd = String(today.getDate()).padStart(2, '0')
      const yyyy = today.getFullYear()
      const formattedDate = `${mm}/${dd}/${yyyy}`
      const PatientDummyData = -1

      //  await addedNewPaitentDatainLS()
      const tempId = Math.floor(10000 + Math.random() * 90000)

      const NewPatientData = {
        MODE: 'insert',
        patientData: JSON.stringify({ ...childformData, createdDate: formattedDate }),
        facility: JSON.stringify(a),
        id: tempId,
        insurance: {},
      }

      //  let resultData = await SavePatients('Insert', JSON.stringify({ ...childformData, createdDate: formattedDate }), JSON.stringify(a), '', PatientDummyData, '{}')
      toast.success('Patient Added Successfully', toastConfig)

      const newPatientData = {
        ...childformData,
        FacilityName: patinetWithFacilityData?.label.toString() || '',
        Room: facility?.roomNumber || -1,
        PatientID: tempId,
        createdDate: formattedDate,
      }

      await updatePatientMasterData(newPatientData)
      const finalPatientID = tempId
      let addedAppointment
      if (finalPatientID) {
        const noteForNewPatientData = await handleSubmitNote(finalPatientID)
        console.log('noteData-->', noteForNewPatientData)
        await saveNewPatientData([...getAllPatientData, { NewPatientData, noteForNewPatientData }])
        if (noteForNewPatientData?.id) {
          addedAppointment = await handleSchdulePatinet(noteForNewPatientData?.id, newPatientData)
        }

        console.log('Newly Added Appoinement', addedAppointment)
        if (noteForNewPatientData) {
          // const getTodaysAppointmentData = await getAllTodaysAppointment()

          const today = new Date()
          const todayFormatted = String(today.getMonth() + 1).padStart(2, '0') + '/' + String(today.getDate()).padStart(2, '0') + '/' + today.getFullYear()

          const updatePatientList = {
            ...childformData,
            FacilityName: patinetWithFacilityData?.label.toString() || '',
            Room: facility?.roomNumber || -1,
            PatientID: tempId,
            createdDate: formattedDate,
            AddonPatient: true,
          }

          const newTodaysAppoinmentData = {
            ...childformData,
            FacilityName: patinetWithFacilityData?.label.toString() || '',
            Room: facility?.roomNumber || -1,
            PatientID: tempId,
            createdDate: formattedDate,
            noteFlag: 'true',
            noteStatus: 'Submitted',
            allNotes: [noteForNewPatientData],
            appointmentScheduleDate: todayFormatted,
            appointmentData: addedAppointment?.data,
            appointmentID: addedAppointment?.data?.AppointmentID,
            patientData: updatePatientList,
            AddedByApp: true,
            Diagnosis: '',
          }

          console.log('sending', newTodaysAppoinmentData)
          //  const newTodaysData = [ ...parsedNotes , newTodaysAppoinmentData]
          const newList = [...filteredPatientData, newTodaysAppoinmentData]
          const patientAllData = [...patientData, updatePatientList]
          setFilteredPatientData(newList)
          await saveAllTodaysAppointment(JSON.stringify(newList))
          await GetAppointmentsAllDataInDbForAddonPatient(newList, patientAllData)

          //  setPatientData(patientAllData)
          console.log('[...prev , newTodaysAppoinmentData]', [newTodaysAppoinmentData], patientAllData)
        }
      }

      const exitAppointment = await getAllAppointmentDetails()

      const mergerAppointment = [...exitAppointment, addedAppointment]
      console.log('mergerAppointmen', mergerAppointment)

      resetStates()
      setPatientID('')
      setCreatingPatientLoader(false)
      saveAllAppointmentDetails(mergerAppointment)
    } catch (error) {
      setCreatingPatientLoader(false)
      console.log('Failed to save patient data. Please try again.', error)
      toast.error('Failed to save patient data. Please try again.', toastConfig)
    }
  }

  const [verifyPatientData, setShowVerifyPatientData] = useState(null)
  const handleVerifyData = async (patient) => {
    console.log('patient verify', patient)
    setShowVerifyModel(true)
    setShowVerifyPatientData(patient)
  }

  console.log('verifyFormData', verifyFormData)

  const cleaerVerifyForm = () => {
    setVerifyFormData({
      patientSeen: true,
      notSeenReason: '',
      otherReason: '',
      term: '',
    })
    setShowVerifyModel(false)
  }

  const handleVerifyButton = (key, value) => {
    console.log('verifyform ', key, value)

    setVerifyFormData((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const verifyPatinetOption = [
    { value: 'discharged', label: 'Discharged' },
    { value: 'patientNotInFacility', label: 'Patient not in facility' },
    { value: 'other', label: 'Other' },
  ]

  const handleCheckVerified = (appointmentID) => {
    const verifiedData = JSON.parse(localStorage.getItem('verifiedPatients')) || {}
    return verifiedData[appointmentID]?.verified === true
  }

  const handleCheckVerifiedData = (patientID, patientData, appointmentID) => {
    console.log('patientData--->', patientData)
    const isVerified = handleCheckVerified(appointmentID)

    if (isVerified) {
      // toggleSidebar()
      getIntoNoteLatestHandle(patientID, patientData)
    } else {
      handleVerifyData(patientData)
    }
  }

  const updateOfflinePatientData = async (AppointmentData, patientID) => {
    console.log('AppointmentData,patientID', AppointmentData, patientID)
    const data = await getOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }

    const updatedPatientData = {
      ...patientData,
      appointmentData: AppointmentData?.data,
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    console.log('ordeer update in ls ', updatedData)
    await saveOfflineData(updatedData)
  }

  const updateAddonPatientData = async (patientID) => {
    console.log('AppointmentData,patientID', patientID)
    const data = await getOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const existingAppointmentData = patientData?.appointmentData || {}

    const updateAppointmentData = {
      ...existingAppointmentData,
      term: verifyFormData?.term,
    }

    const updatedPatientData = {
      ...patientData,
      appointmentData: updateAppointmentData,
    }

    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    console.log('ordeer update in ls ', updatedData)
    await saveOfflineData(updatedData)
  }

  const updatePatientTypeForSchedule = async () => {
    try {
      const date = formatDateFilter(new Date())
      const allAppointments = await getAllAppointments('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)
      console.log('addon appointmentRunddddd ', verifyPatientData.PatientID, allAppointments.length)
      if (allAppointments.length === 0 || !verifyPatientData?.PatientID) return

      const matchAppointment = allAppointments.find((appt) => appt.patientID === verifyPatientData.PatientID)
      console.log(matchAppointment, 'matchAppointment')

      if (!matchAppointment) {
        await updateAddonPatientData(verifyPatientData.PatientID)
        return
      }

      const allMatchedAppointmentAppointmentDetails = matchAppointment?.appointmentDetails || []

      console.log(allMatchedAppointmentAppointmentDetails, 'allMatchedAppointmentAppointmentDetails')

      if (allMatchedAppointmentAppointmentDetails.length === 0) return

      const AppointmentToUpdate = allMatchedAppointmentAppointmentDetails.find((item) => item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled')

      if (!AppointmentToUpdate) return

      console.log('AppointmentToUpdate', AppointmentToUpdate)

      const updatedData = {
        ...AppointmentToUpdate,
        data: {
          ...AppointmentToUpdate?.data,
          term: verifyFormData?.term,
        },
      }

      await updateOfflinePatientData(updatedData, verifyPatientData.PatientID)
      const updatedAllMatchedAppointmentDetails = allMatchedAppointmentAppointmentDetails.map((item) => {
        if (item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled') {
          return updatedData
        }
        return item
      })

      console.log(updatedAllMatchedAppointmentDetails, 'updatedAllMatchedAppointmentDetails')

      const updatedMatched = {
        ...matchAppointment,
        appointmentDetails: updatedAllMatchedAppointmentDetails,
      }

      const findAppointmentInRawData = await getAllAppointments('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)
      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)

      if (!findAppointmentInRawData) return

      console.log(findAppointmentInRawData, 'findAppointmentInRawData')
      const findPatientAppointments = findAppointmentInRawData.map((item) => {
        if (item?.patientID === verifyPatientData.PatientID) {
          return updatedMatched
        }
        return item
      })

      console.log('findPatientAppointments', findPatientAppointments)

      if (findPatientAppointments.length > 0) {
        console.log('running updating the appointment detail')
        await PatientAppointmentDetails('UPDATE', ID, date, loggedUserProvider?.ID, JSON.stringify(findPatientAppointments))
      }
    } catch (error) {
      console.error('error while scheduling', error)
    }
  }

  const handleVerifySubmit = (verifyInfoData) => {
    const storedData = JSON.parse(localStorage.getItem('verifiedPatients')) || {}
    console.log('verifyInfoData-->', verifyFormData)
    if (verifyFormData?.patientSeen == false) {
      addNoteSeenData(verifyFormData, verifyInfoData?.PatientID)
      // updateScheduleDataWithPatientSeenType()
    }
    if (verifyFormData?.term !== '') {
      updatePatientTypeForSchedule()
    }
    storedData[verifyInfoData.appointmentID] = {
      verified: true,
    }
    localStorage.setItem('verifiedPatients', JSON.stringify(storedData))

    if (verifyFormData?.patientSeen) {
      getIntoNoteLatestHandle(verifyInfoData?.PatientID, verifyInfoData)
    }
    // toggleSidebar()

    cleaerVerifyForm()
    setShowVerifyModel(false)
  }

  // const updatePatientTodaysAppointment = async (ID) => {
  //   const getTodaysAppointment = await getAllTodaysAppointment()
  //   const parsedAppointment = JSON.parse(getTodaysAppointment)
  //   const filterAppointment = parsedAppointment.filter((item) => item.PatientID !== parseInt(ID))
  //   let preSignedNote = parsedAppointment.find((item) => item.PatientID === parseInt(ID))
  //   console.log('filter AppointmentData', filterAppointment)
  //   setFilteredPatientData(filterAppointment)
  //  await saveAllTodaysAppointment(JSON.stringify(filterAppointment))
  // }

  const updatePatientTodaysAppointment = async (ID) => {
    const getTodaysAppointment = await getAllTodaysAppointment()
    const parsedAppointment = JSON.parse(getTodaysAppointment)
    const filterAppointment = parsedAppointment.filter((item) => item.PatientID !== parseInt(ID))
    let preSignedNote = parsedAppointment.find((item) => item.PatientID === parseInt(ID))

    const updatedPatientData = {
      ...preSignedNote,
      SuperBillStatus: 'Not Seen',
      allNotes: Array.isArray(preSignedNote.allNotes)
        ? preSignedNote.allNotes.map((note) => ({
          ...note,
          status: 'Pre-Signed Not Seen',
        }))
        : [],
    }

    console.log('filter AppointmentData', filterAppointment)
    setFilteredPatientData(filterAppointment)
    await saveAllTodaysAppointment(JSON.stringify(filterAppointment))

    let getExistingPreSignedAppoiintment = await getPreSignedAppointment()

    console.log('getExistingPreSignedAppoiintment', getExistingPreSignedAppoiintment)

    let parsedNotes = []

    if (typeof getExistingPreSignedAppoiintment === 'string' && getExistingPreSignedAppoiintment.trim()) {
      try {
        const parsed = JSON.parse(getExistingPreSignedAppoiintment)
        parsedNotes = Array.isArray(parsed) ? parsed : []
      } catch (err) {
        parsedNotes = []
      }
    } else {
      parsedNotes = []
    }

    const updatePreSignedData = [...parsedNotes, updatedPatientData]
    console.log('updatePreSignedData', updatePreSignedData, parsedNotes, updatedPatientData)

    await savePreSignedAppointment(JSON.stringify(updatePreSignedData))
  }

  // const addNoteSeenData = async (verifyFormData, patientID) => {
  //   const data = await getOfflineData()
  //   const loggedUser = await getProviderDetails()
  //   const loggedUserID = loggedUser?.ID
  //   const userData = { ...(data[loggedUserID] || {}) }
  //   const patientData = { ...(userData[patientID] || {}) }
  //   const newlyAddedData = patientData.newlyAddedData || []

  //   console.log('patinent data for seen patient', data, patientData, patientID)

  //   await updatePatientTodaysAppointment(verifyPatientData?.PatientID)

  //   const notSeenData = {
  //     verifyFormData,
  //     patientID,
  //   }

  //   const updatedPatientData = {
  //     ...patientData,
  //     newlyAddedData: { ...newlyAddedData, notSeenData },
  //   }

  //   const updatedUserData = {
  //     ...userData,
  //     [patientID]: updatedPatientData,
  //   }

  //   const updatedData = {
  //     ...data,
  //     [loggedUserID]: updatedUserData,
  //   }

  //   await saveOfflineData(updatedData)
  // }

  const addNoteSeenData = async (verifyFormData, patientID) => {
    const data = await getOfflineData()
    const loggedUser = await getProviderDetails()
    const existingPreSignedData = (await getPreSignedData()) || {}
    const loggedUserID = loggedUser?.ID
    const userData = { ...(data[loggedUserID] || {}) }
    const patientData = { ...(userData[patientID] || {}) }
    const newlyAddedData = patientData.newlyAddedData || []

    console.log('preaDat--->', data, patientData, patientID, newlyAddedData)

    await updatePatientTodaysAppointment(verifyPatientData?.PatientID)

    const notSeenData = {
      verifyFormData,
      patientID,
    }

    const currentNote = {
      ...patientData.currentNote,
      noteLocalStatus: 'preNotSigned',
    }

    const updatedPatientData = {
      ...patientData,

      allNotes: Array.isArray(patientData.allNotes)
        ? patientData.allNotes.map((note) => ({
          ...note,
          status: 'Pre-Signed Not Seen',
        }))
        : [],
      newlyAddedData: { ...newlyAddedData, notSeenData, currentNote },
    }
    console.log('updatedPatientData', updatedPatientData)
    const updatedUserData = {
      ...userData,
      [patientID]: updatedPatientData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    const updatedPreSignedData = {
      ...existingPreSignedData,
      [loggedUserID]: {
        ...(existingPreSignedData?.[loggedUserID] || {}),
        [patientID]: updatedPatientData,
      },
    }

    await savePreSignedData(updatedPreSignedData)
    // await saveOfflineData(updatedData)
  }

  const updateScheduleDataWithPatientSeenType = async () => {
    const date = formatDateFilter(new Date())
    const allAppointments = await getAllAppointments('GET', date, loggedUserProvider?.ID)
    if (!verifyPatientData?.PatientID || allAppointments.length === 0) return

    const matchAppointment = allAppointments.find((appt) => appt.patientID === verifyPatientData.PatientID)
    console.log(matchAppointment, 'matchAppointment')

    if (!matchAppointment) return

    const allMatchedAppointmentAppointmentDetails = matchAppointment?.appointmentDetails || []

    console.log(allMatchedAppointmentAppointmentDetails, 'allMatchedAppointmentAppointmentDetails')

    if (allMatchedAppointmentAppointmentDetails.length === 0) return

    const AppointmentToUpdate = allMatchedAppointmentAppointmentDetails.find((item) => item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled')

    if (!AppointmentToUpdate) return

    console.log('AppointmentToUpdate', AppointmentToUpdate)

    const updatedData = {
      ...AppointmentToUpdate,
      data: {
        ...AppointmentToUpdate?.data,
        // Status:"Rescheduled",
        patientSeen: verifyFormData.patientSeen,
        notSeenReason: verifyFormData?.notSeenReason,
        customReason: verifyFormData?.otherReason || '',
        term: verifyFormData?.term,
      },
    }

    const updatedAllMatchedAppointmentDetails = allMatchedAppointmentAppointmentDetails.map((item) => {
      if (item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled') {
        return updatedData
      }
      return item
    })

    console.log(updatedAllMatchedAppointmentDetails, 'updatedAllMatchedAppointmentDetails')

    const updatedMatched = {
      ...matchAppointment,
      appointmentDetails: updatedAllMatchedAppointmentDetails,
    }

    const findAppointmentInRawData = await getAllAppointments('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)
    const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', date, loggedUserProvider?.ID)

    if (!findAppointmentInRawData) return

    console.log(findAppointmentInRawData, 'findAppointmentInRawData')
    const findPatientAppointments = findAppointmentInRawData.map((item) => {
      if (item?.patientID === verifyPatientData.PatientID) {
        return updatedMatched
      }
      return item
    })

    console.log('findPatientAppointments', findPatientAppointments)

    if (findPatientAppointments.length > 0) {
      console.log('running updating the appointment detail')
      await PatientAppointmentDetails('UPDATE', ID, date, loggedUserProvider?.ID, JSON.stringify(findPatientAppointments))
    }
  }

  const getLatestData = async () => {
    try {
      const result = await PatientAppointmentDetails('GET', '', '', '', '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '')
      const rawData = JSON.parse(result.d)?.Data || []

      return rawData.map((item) => {
        return {
          ...item,
          AppointmentDetails: JSON.parse(item?.AppointmentDetails),
        }
      })
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
    }
  }

  const handleDeleteAppointment = async () => {
    if (!deletePatientID) {
      toast.error('delete ID not found', toastConfig)
      return
    }

    try {
      const latestData = await getLatestData()
      console.log(latestData, 'latestData')

      // Get schedules that contain the patient
      const filterAppointments = latestData.filter((schedule) => schedule.AppointmentDetails.some((patient) => patient.patientID === deletePatientID))

      if (!filterAppointments.length) {
        // toast.error('Patient not found in any schedule', toastConfig);
        return
      }

      const filterAppointmentWithoutPatientAppointment = filterAppointments.map((item) => ({
        ...item,
        AppointmentDetails: item.AppointmentDetails.filter((patient) => patient.patientID !== deletePatientID),
      }))

      if (!filterAppointmentWithoutPatientAppointment.length) {
        // toast.error('Patient not found in any schedule', toastConfig);
        return
      }

      console.log(filterAppointments, filterAppointmentWithoutPatientAppointment, 'filterAppointments')

      try {
        await Promise.all(filterAppointmentWithoutPatientAppointment.map((item) => PatientAppointmentDetails('UPDATE', item.ID, item.ScheduleDate, item.ProviderID, JSON.stringify(item.AppointmentDetails), item.CreatedDate)))

        getAppointmentData()
      } catch (error) {
        console.log('error while deleting', error)
      }
    } catch (e) {
      console.error('Error', e)
    }
  }

  const handleDeletePatient = async () => {
    const cachedNotesData = await getAllTodaysAppointment()
    let parsedNotes = JSON.parse(cachedNotesData)
    const filterParsedNote = parsedNotes.filter((item) => item?.PatientID !== deletePatientID)
    console.log(filterParsedNote, parsedNotes, 'parsedNotesparsedNotes')
    let data = await getOfflineData()
    console.log(data, 'deleting data...')

    if (data && data?.[loggedUserProvider?.ID]?.[deletePatientID]) {
      console.log(data, 'data offline before deleting data...')
      delete data[loggedUserProvider?.ID][deletePatientID]
    }
    console.log(data, 'data offline after deleting data...')
    await saveOfflineData(data)
    await saveAllTodaysAppointment(JSON.stringify(filterParsedNote))
    setFilteredPatientData(filterParsedNote)
    setDeletePatientID(null)
    setDeleteVisible(false)
    setShowVerifyModel(false)
  }

  const handleDeletePatientData = (patientID) => {
    setDeleteVisible(true)
    setDeletePatientID(patientID)
  }

  const handleEditPatient = (rowSelected) => {
    console.log('facility data', rowSelected)

    setFacility((prev) => ({
      ...prev,
      facility: rowSelected?.FacilityName,
      roomNumber: rowSelected?.Room,
    }))
    const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
    setPatinetWithFacilityData(userFacilities)
    setPatientID(rowSelected?.PatientID)
    setChildFormData({
      FirstName: rowSelected?.FirstName || '',
      MiddleName: rowSelected?.MiddleName || '',
      LastName: rowSelected?.LastName || '',
      DOB: rowSelected?.DOB || '',
      Gender: rowSelected?.Gender || '',
      Age: rowSelected?.Age || '0',
      PhoneNumber: rowSelected?.PhoneNumber || '',
      EmergencyName: rowSelected?.EmergencyName || '',
      EmergencyPhone: rowSelected?.EmergencyPhone || '',
      Address: rowSelected?.Address || '',
      State: rowSelected?.State || '',
      City: rowSelected?.City || '',
      ZipCode: rowSelected?.ZipCode || '',
      Country: rowSelected?.Country || '',
      Status: rowSelected?.Status || '',
    })
    setEditModalVisible(true)
  }

  const handleEditPatinetSubmit = async () => {
    const isValid = validatePatientForm()
    if (!isValid) {
      toast.error('Please fill all required fields', toastConfig)
      return
    }
    setCreatingPatientLoader(true)
    try {
      let a = {
        FacilityID: patinetWithFacilityData?.value?.toString() || '',
        FacilityName: patinetWithFacilityData?.label?.toString() || '',
        Room: facility?.roomNumber || -1,
      }

      let insurances = addedInsurances.map((ins) => ({
        InsuranceID: ins?.ID,
      }))

      let savePatientInfo
      if (patientID && patientID !== '') {
        savePatientInfo = SavePatients('Update', JSON.stringify(childformData), JSON.stringify(a), '', patientID, JSON.stringify(insurances))
      }

      console.log('await savePatientInfo', await savePatientInfo)
      setTimeout(async () => {
        await patientDataFn()
      }, 1000)
      resetStates()
      getAppointmentData()
      getData()
      setShowVerifyModel(false)
    } catch (error) {
      console.error('Error while editing patient:', error)
      // optional: show toast or alert
      // toast.error("Something went wrong while saving patient")
    } finally {
      setCreatingPatientLoader(false)
    }
  }

  const GetMasterMedications = async () => {
    try {
      let allMedicines = await MedicineCRUD('GET')
      let formattedData = JSON.parse(allMedicines.d)?.Data
      if (formattedData) {
        formattedData = formattedData.map((item) => {
          let itemData = JSON.parse(item.Data)
          return {
            ...item,
            Data: {
              ...itemData,
              diagnoses: itemData.diagnoses.split(',').map((diagnosis) => diagnosis.trim()),
            },
          }
        })
        console.log('medication data-->', formattedData)
        return formattedData
      }
    } catch (error) {
      console.error('Error fetching master medications:', error)
    }
  }

  const [downloadingData, setDownloadingData] = useState(false)
  const [inProcessText, setInProcessText] = useState('Master')
  const [progress, setProgress] = useState(0)
  const [elapsedTime, setElapsedTime] = useState(0)
  const cancelRequested = useRef(false)

  useEffect(() => {
    let interval = null
    if (downloadingData) {
      setElapsedTime(0)
      interval = setInterval(() => {
        setElapsedTime((prevTime) => prevTime + 1)
      }, 1000)
    } else {
      setElapsedTime(0)
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [downloadingData])

  const getCurrentStep = () => {
    if (progress < 20) return 1
    if (progress < 80) return 2
    if (progress < 90) return 3

    return 3
  }

  const currentStep = getCurrentStep()

  const steps = [
    { id: 1, label: 'Downloading' },
    { id: 2, label: 'Setting Up Master' },
    { id: 3, label: 'Completed' },
  ]

  const [masterDownloadedToday, setMasterDownloadedToday] = useState(() => {
    const stored = localStorage.getItem('masterDownloadedToday')
    if (!stored) return false

    return new Date(stored).toDateString() === new Date().toDateString()
  })

  const [isChangesMadeInMaster, setIsChangesMadeInMaster] = useState(false)
  const [isCheckingForChanges, setIsCheckingForChanges] = useState(false)

  const isMasterDownloadDisabled = useMemo(() => {
    if (isCheckingForChanges) return true
    if (masterDownloadedToday) return true
    return isCheckingForChanges || downloadingData || masterDownloadedToday
  }, [isCheckingForChanges, downloadingData, masterDownloadedToday])

  const isMasterShowRedBorder = useMemo(() => {
    if (isCheckingForChanges) return false
    if (masterDownloadedToday) return false
    return (isChangesMadeInMaster && !masterDownloadedToday) || !masterDownloadedToday || !isCheckingForChanges
  }, [isChangesMadeInMaster, masterDownloadedToday, isCheckingForChanges])
  useEffect(() => {
    const checkForMasterDataChanges = async () => {
      try {
        setIsCheckingForChanges(true)
        const result = await SaveExtra('Get_By_Type', 'activity_log', '', '')
        let activityLogs = JSON.parse(result.d)?.Data || []

        const logRow = activityLogs.find((item) => item.Id === 6470)

        const lastUpdated = logRow ? JSON.parse(logRow.JsonData)?.masterActivity?.date : null

        const storedData = localStorage.getItem('masterDownloadedToday')

        console.log(lastUpdated, storedData, lastUpdated && storedData, 'get time values 1')

        if (lastUpdated && storedData) {
          const lastUpdatedDate = new Date(lastUpdated)
          const storedDate = new Date(storedData)
          if (lastUpdatedDate.getTime() > storedDate.getTime()) {
            console.log('get time values 3 greater')
            setIsChangesMadeInMaster(true)
            setIsCheckingForChanges(false)
          } else {
            setIsChangesMadeInMaster(false)
            setIsCheckingForChanges(false)
          }
        } else {
          setIsChangesMadeInMaster(false)
          setIsCheckingForChanges(false)
        }
      } catch (e) {
        setIsChangesMadeInMaster(false)
        console.log(e, 'error checking master')
      }
    }

    checkForMasterDataChanges()
  }, [masterDownloadedToday])

  // useEffect(() => {
  //   if (masterDownloadedToday) {
  //     localStorage.setItem("masterDownloadedToday", new Date().toISOString());
  //   }
  // }, [masterDownloadedToday]);

  useEffect(() => {
    const stored = localStorage.getItem('masterDownloadedToday')
    if (!stored) return

    const storedDate = new Date(stored).toDateString()
    const today = new Date().toDateString()

    if (storedDate !== today) {
      localStorage.removeItem('masterDownloadedToday')
    }
  }, [])

  const DownloadMasterData = async () => {
    console.log(new Date(), 'downloading data')

    try {
      setProgress(0)

      setDownloadingData(true)
      cancelRequested.current = false

      const totalSteps = 13

      let currentStep = 0

      const updateProgress = () => {
        currentStep++
        setProgress(Math.round((currentStep / totalSteps) * 100))
      }

      const checkCancel = () => {
        if (cancelRequested.current) {
          toast.error('Download cancelled by provider.', toastConfig)
          throw new Error('Download Cancelled')
        }
      }
      // Step 1: Fetch Assessment Suggestions

      setInProcessText('Fetching Assessment Data -')

      let assessmentSuggestionData = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')

      assessmentSuggestionData = JSON.parse(assessmentSuggestionData.d)?.Data || []

      if (assessmentSuggestionData) {
        assessmentSuggestionData = assessmentSuggestionData?.map((item) => {
          return {
            Id: item.Id,

            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      updateProgress()
      checkCancel()

      setInProcessText('Fetching HPI, Subjective & Incident -')

      const types = ['HPI', 'followup', 'Incident']

      const response = await GetDiagnosisData()

      const data = JSON.parse(response.d)

      const options = data.Data.sort((a, b) => a.Name.trim().localeCompare(b.Name.trim())).map((obj) => ({
        value: obj.id,

        label: obj.Name.trim(),
      }))

      const diagnosisData = {}

      for (const option of options) {
        const diagnosisName = option.label

        if (!diagnosisData[diagnosisName]) {
          diagnosisData[diagnosisName] = {}
        }

        for (const type of types) {
          if (!diagnosisData[diagnosisName][type]) {
            diagnosisData[diagnosisName][type] = {}
          }

          let formattedData = await SaveQuestionProvider('GET', '', type, option.value.toString(), '')
          checkCancel()

          if (formattedData) {
            formattedData = JSON.parse(formattedData.d)?.Data || []

            formattedData = formattedData[0] || []

            if (formattedData.questionData) {
              formattedData = {
                ...formattedData,

                questionData: JSON.parse(formattedData.questionData).filter((item) => item !== null),
              }
            }

            diagnosisData[diagnosisName][type] = formattedData
          }
        }
      }

      updateProgress()
      // checkCancel()

      const peData = {
        General: {},
        Diagnosis: {},
      }

      // Step 2: Fetch General Plan Statements

      setInProcessText('Fetching Plan Statements -')

      let generalPlanStatements = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')

      generalPlanStatements = JSON.parse(generalPlanStatements.d)?.Data || []

      if (generalPlanStatements) {
        generalPlanStatements = generalPlanStatements.map((item) => ({
          Id: item.Id,

          Data: JSON.parse(item?.JsonData),
        }))
      }

      updateProgress()
      checkCancel()

      // Step 3: Fetch Differential Diagnosis

      setInProcessText('Fetching Differential Diagnosis -')

      let differentialDiagnosisData = await SaveExtra('Get_By_Type', 'differentialDiagnosis', '', '')

      differentialDiagnosisData = JSON.parse(differentialDiagnosisData.d)?.Data || []

      if (differentialDiagnosisData) {
        differentialDiagnosisData = differentialDiagnosisData.map((item) => ({
          Id: item.Id,

          Data: JSON.parse(item?.JsonData),
        }))
      }

      updateProgress()
      checkCancel()
      // Step 4: Fetch PE Data

      setInProcessText('Fetching PE Data -')

      let dataDiagnosisExaminationDummyData = await SaveExtra('Get_By_Type', 'DiagnosisExaminationDummyData', '', '')

      dataDiagnosisExaminationDummyData = JSON.parse(dataDiagnosisExaminationDummyData.d)?.Data || []

      if (dataDiagnosisExaminationDummyData) {
        dataDiagnosisExaminationDummyData = dataDiagnosisExaminationDummyData?.map((item) => {
          return {
            Id: item.Id,

            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      peData.Diagnosis = dataDiagnosisExaminationDummyData[0]?.Data

      let dataPhysicalExaminationDummyData = await SaveExtra('Get_By_Type', 'PhysicalExaminationDummyData', '', '')

      dataPhysicalExaminationDummyData = JSON.parse(dataPhysicalExaminationDummyData.d)?.Data || []

      if (dataPhysicalExaminationDummyData) {
        dataPhysicalExaminationDummyData = dataPhysicalExaminationDummyData?.map((item) => {
          return {
            Id: item.Id,

            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      peData.General = dataPhysicalExaminationDummyData[0]?.Data

      updateProgress()
      checkCancel()
      // Step 5: Fetch Imaging Data

      setInProcessText('Fetching Imaging Data -')

      let allFormattedData = []
      let formattedDataAllImaging = []
      let formattedImagingData

      const Imaging = await ImagingInformation('GET_ALL')

      if (Imaging) {
        formattedDataAllImaging = JSON.parse(Imaging.d)?.Data
        formattedImagingData = JSON.parse(Imaging.d)?.Data

        allFormattedData = formattedDataAllImaging.map((item) => {
          return {
            ID: item.ID,
            Name: item.Name,
          }
        })
      }
      console.log(formattedDataAllImaging, 'formattedDataAllImaging')

      updateProgress()
      checkCancel()
      // Step 6: Fetch Lab Data

      setInProcessText('Fetching Lab Data -')

      let labData = await LabCRUD('GETALL', '{}')

      labData = JSON.parse(labData.d)?.Data

      updateProgress()
      checkCancel()
      // Step 7: Fetch Medication Data

      setInProcessText('Fetching Medication Data -')

      let allMedsResponse
      const allMedicines = await MedicineCRUD('GET')
      allMedsResponse = JSON.parse(allMedicines?.d || '{}')

      let formateMedationData = []

      try {
        const medicinesData = JSON.parse(allMedicines?.d || '{}')?.Data || []

        formateMedationData = medicinesData.map((item) => {
          try {
            return JSON.parse(item?.Data || '{}')
          } catch {
            return {}
          }
        })
      } catch {
        formateMedationData = []
      }

      updateProgress()
      checkCancel()
      // Step 8: Fetch Miscellaneous Data

      setInProcessText('Fetching Miscellaneous Data -')

      const miscellaneous = await SaveExtra('Get_By_Type', 'Miscellaneous', '', '')

      const parsedResponse = JSON.parse(miscellaneous?.d || '{}')

      const miscellaneousData = (parsedResponse?.Data || []).map((item) => {
        const jsonData = JSON.parse(item?.JsonData || '{}')

        return { Id: item.Id, ...jsonData }
      })

      updateProgress()
      checkCancel()
      // Step 9: Save All Data

      setInProcessText('Saving Data -')

      let educationMasterdata = await SaveExtra('Get_By_Type', 'Education', '', '')

      educationMasterdata = JSON.parse(educationMasterdata.d)?.Data || []
      if (educationMasterdata) {
        educationMasterdata = educationMasterdata?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      updateProgress()
      checkCancel()

      const responseRisks = await GetDiagnosisData('Risks')
      const responseRisksData = JSON.parse(responseRisks.d)?.Data || []

      let a = await GetDiagnosisData()
      let dataDiagnosis = JSON.parse(a.d)
      let optionsDiagnosis = []
      dataDiagnosis.Data.map((obj) => {
        optionsDiagnosis.push({
          value: obj.id,
          label: obj.Name.trim(),
        })
      })

      console.log(dataDiagnosis, 'dataDiagnosis')

      const promises = (dataDiagnosis?.Data || []).map(async (item) => {
        try {
          const componentData = await GetQuestionBank('', item?.Name, '')
          console.log(componentData, 'componentData for poac', item?.Name)
          return { name: item?.Name, data: componentData || {} }
        } catch (e) {
          console.error('Error fetching question bank:', e)
          return { name: item?.Name, data: {} }
        }
      })

      const results = await Promise.all(promises)

      const poacMasterData = {}
      results.forEach(({ name, data }) => {
        poacMasterData[name] = data
      })

      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      const getUser = JSON.parse(localStorage.getItem('user'))

      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)

      /// step :11 provider List
      let providerDatasList = await fetchPatientData('SELECT', 'Provider', '{}')
      const providerList = JSON.parse(providerDatasList.d)

      providerDatasList = providerList.Data
      let newProviders = []
      for (let i = 0; i < providerDatasList.length; i++) {
        let c = await getAllProviderDetails(providerDatasList[i])
        newProviders.push(c)
      }

      updateProgress()
      checkCancel()

      ///step : 12

      let facilityDetails = await FacilityCRUD('SELECT', {})
      facilityDetails = JSON.parse(facilityDetails.d)?.Data
      updateProgress()
      checkCancel()

      ///step : 13 all appointment data

      const allAppointmentData = await PatientAppointmentDetails('GET', '', '', '', '')
      updateProgress()
      checkCancel()

      // step 14

      // const medMasterWithId = await GetMasterMedications()

      //  updateProgress()
      //  checkCancel()

      // step 15

      const allAppointmentDetails = await getAllAppointmentsDetails('GET')

      //step 16

      //  let patientData = await SavePatients('GetAll', '', '', '')
      // const  AllPatient = JSON.parse(patientData.d).Data

      // saveCallCenterQuestions

      const callCenter = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
      let dataCallCenter = JSON.parse(callCenter?.d)

      console.log('all master data', {
        generalPlanStatements,
        assessmentSuggestionData,
        diagnosisData,
        differentialDiagnosisData,
        peData,
        allFormattedData,
        formattedDataAllImaging,
        labData,
        formateMedationData,
        response,
        miscellaneousData,
        newProviders,
        facilityDetails,
        educationMasterdata: educationMasterdata[0]?.Data,
        dataDiagnosis,
        optionsDiagnosis,
        responseRisksData,
        poacMasterData,
        foundProvider,
        allAppointmentData,
        formattedImagingData,
        allMedsResponse,
        allAppointmentDetails,
      })

      await saveGeneralPlanStatement(generalPlanStatements)
      await saveAssSuggMasterData(assessmentSuggestionData)
      await saveHPIDiagnosisData(diagnosisData)
      await saveDifferntialDiagnosis(differentialDiagnosisData)
      await savePEData(peData)
      await saveImagingMasterData(allFormattedData)
      await saveImagingDetailsAllMaster(formattedDataAllImaging)
      await saveLabMasterData(labData)
      await saveMedicationMasterData(formateMedationData)
      await saveDiagnosisReponseData(response)
      await saveMiscellaneousMaster(miscellaneousData)
      await saveProviderList(newProviders)
      await saveFacilityData(facilityDetails)
      await saveEducationMaster(educationMasterdata[0]?.Data)
      await saveAllMasterDiagnosis(dataDiagnosis)
      await saveAllMasterDiagnosisOptions(optionsDiagnosis)
      await saveRiskFactorMaster(responseRisksData)
      await savePOACMaster(poacMasterData)
      await saveProviderDetails(foundProvider || {})
      await saveAllAppointmentData(allAppointmentData)
      await saveAllAppointmentDetails(allAppointmentDetails)
      await saveImagingInformationData(formattedImagingData)
      await saveMedicationinformationData(allMedsResponse)
      await saveCallCenterQuestions(dataCallCenter)
      // await savePatientDetails(AllPatient)

      // await savePatientHpi(dataHPiPatient)

      setDownloadingData(false)

      setProgress(0)
      setMasterDataAvailable(false)
      toast.success('Data Downloaded Successfully', toastConfig)
      checkData()
      console.log(new Date(), 'downloading data')
      setMasterDownloadedToday(true)
      localStorage.setItem('masterDownloadedToday', new Date().toISOString())
      setIsChangesMadeInMaster(false)
      window.reload()
      toast.success('Data Downloaded Successfully', toastConfig)
    } catch (error) {
      setProgress(0)
      setDownloadingData(false)
      checkData()
    }
  }

  const downLoadTodaysPatient = async () => {
    setIsPageLoading(true)
    await GetPatientTreatmentsNotes()
    setIsPageLoading(false)
    localStorage.setItem('isPatientListLoadedToday', new Date().toISOString())
    setIsPatientLoadedToday(true)
  }

  const [masterDataAvailable, setMasterDataAvailable] = useState(false)
  const checkData = async () => {
    const hasData = await checkIfMastersExist()
    console.log('hasData', hasData)
    if (!hasData) {
      setMasterModel(true)
      setMasterDataAvailable(true)
    }
    return hasData
  }

  useEffect(() => {
    checkData()
  }, [])

  const [selectedPatientId, setSelectedPatientId] = useState(null)
  const timeoutRef = useRef(null)

  //  const [appointmentProgress, setAppointmentProgress] = useState(0)
  const [showModal, setShowModal] = useState(false)
  // useEffect(() => {
  //   let timer;

  //   if (isRefreshLoad) {
  //     setAppointmentProgress(0);

  //     timer = setInterval(() => {
  //       setAppointmentProgress((prev) => {

  //         const next = prev + 3;
  //         return next >= 99 ? 99 : next;
  //       });
  //     }, 100);
  //   } else {

  //     setAppointmentProgress(100);
  //   }

  //   return () => clearInterval(timer);
  // }, [isRefreshLoad]);

  // useEffect(()=>{
  //     checkUploadPatient()
  // },[])

  console.log('selectedPatientId', selectedPatientId)
  return (
    <>
      <div className="" style={{ height: '100vh' }}>
        {showPatientInfo ? (
          <PatientInfoTodaysAppointments
            hpiAdded={hpiAdded}
            setHpiAdded={setHpiAdded}
            setAllAppointmentRawData={setAllAppointmentRawData}
            allAppointmentRawData={allAppointmentRawData}
            isAllotedToProvider={true}
            creatingNewNote={creatingNewNote}
            setCreatingNewNote={setCreatingNewNote}
            childformData={childformData}
            setChildFormData={setChildFormData}
            saveDiagnosisData={saveDiagnosisData}
            changesInTreatmentShell={changesInTreatmentShell}
            setChangesInTreatmentShell={setChangesInTreatmentShell}
            noteStatus={noteStatus}
            patientID={patientIDClicked}
            patientData={rowClicked}
            noteStructureRef={noteStructureRef}
            dataCallType={dataCallType}
            setEditDataId={setEditDataId}
            setDataCallType={setDataCallType}
            noteID={noteID}
            setDataId={setDataId}
            handleAddNoteId={handleAddNoteId}
            appointments={appointments}
            peAdded={peAdded}
            setPEAdded={setPEAdded}
            addedNewIncident={addedNewIncident}
            setAddedNewIncident={setAddedNewIncident}
            rosAdded={rosAdded}
            setRosAdded={setRosAdded}
          />
        ) : setDataId ? (
          <PatientInfoTodaysAppointments
            hpiAdded={hpiAdded}
            setHpiAdded={setHpiAdded}
            isAllotedToProvider={true}
            creatingNewNote={creatingNewNote}
            setCreatingNewNote={setCreatingNewNote}
            childformData={childformData}
            changesInTreatmentShell={changesInTreatmentShell}
            setChangesInTreatmentShell={setChangesInTreatmentShell}
            setChildFormData={setChildFormData}
            saveDiagnosisData={saveDiagnosisData}
            noteStatus={noteStatus}
            patientID={patientIDClicked}
            patientData={rowClicked}
            noteStructureRef={noteStructureRef}
            dataCallType={dataCallType}
            setDataId={setDataId}
            setDataCallType={setDataCallType}
            noteID={noteID}
            setEditDataId={setEditDataId}
            handleAddNoteId={handleAddNoteId}
            appointments={appointments}
            peAdded={peAdded}
            setPEAdded={setPEAdded}
            addedNewIncident={addedNewIncident}
            setAddedNewIncident={setAddedNewIncident}
            rosAdded={rosAdded}
            setRosAdded={setRosAdded}
          />
        ) : (
          <div className=" position-relative ">
            <div>
              {/* Tab Navigation */}
              {/* <div className="d-flex justify-content-center gap-2 my-2">
                <button
                  style={{
                    backgroundColor: `${activeKey === 1 ? '#4363F2' : '#191919'}`,
                    border: '1px solid #333',
                    height: '40px',
                    padding: '5px 14px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    color: '#fff',
                    fontWeight: '500',
                    fontSize: '14px',
                    boxShadow: 'none',
                  }}
                  //   className={`btn ${activeKey === 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setActiveKey(1)}
                >
                  Scheduled
                </button>
                <button
                  style={{
                    backgroundColor: `${activeKey === 2 ? '#4363F2' : '#191919'}`,
                    border: '1px solid #333',
                    height: '40px',
                    padding: '5px 14px',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    color: '#fff',
                    fontWeight: '500',
                    fontSize: '14px',
                    boxShadow: 'none',
                  }}
                  className={`btn ${activeKey === 2 ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setActiveKey(2)}
                >
                  Upload
                </button>
              </div> */}

              {/* Tab Content */}
              <div className="mt-1">
                <CTabContent className="  border-top-0 rounded-bottom">
                  <CTabPane visible={activeKey === 1}>
                    <div className="patient-page-wrapper page-wrapper">
                      <div className="page-header">
                        <div className="d-flex align-items-center gap-2 justify-content-center dark-search">
                          {/* <div className={` search-input ${role == 'provider' ? 'search-dark' : ''}`}>
                            <div className="">
                              <SearchIcon className="" />
                            </div>
                            <div>
                              <input
                                className="input-field-provider-page"
                                onChange={(e) => {
                                  setFilterData({ ...filterData, searchValue: e.target.value })
                                }}
                                type="text"
                                placeholder="Search by Patient..."
                              />
                            </div>
                          </div> */}

                          <div className="" style={{ position: 'relative', display: 'inline-block', marginLeft: '8px', display: 'flex', gap: '10px' }}>
                            <div className="d-flex align-item-center gap-2  ">
                              <CButton
                                style={{
                                  backgroundColor: 'inherit',
                                  border: `1px solid ${isPatientDownloadEnableShowRedBorder ? '#FF0000' : '#333'}`,
                                  height: '40px',
                                  padding: '5px 14px',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '6px',
                                  color: '#fff',
                                  fontWeight: '500',
                                  fontSize: '14px',
                                  boxShadow: 'none',
                                  cursor: 'pointer',
                                }}
                                disabled={isPatientDownloadDisable}
                                onClick={() => downLoadTodaysPatient()}
                              >
                                {isCheckingPatientList ? (
                                  <>
                                    <Spinner size="sm" />
                                    Checking for changes
                                  </>
                                ) : (
                                  <>
                                    <CTooltip content="Refresh Data">{isRefreshLoad ? <Download size={18} /> : <Download size={18} />}</CTooltip>
                                    Download Patients
                                  </>
                                )}
                              </CButton>
                              <CButton
                                className="d-flex align-items-center gap-2"
                                style={{
                                  backgroundColor: 'inherit',
                                  border: `1px solid ${isMasterShowRedBorder ? '#FF0000' : '#333'}`,
                                  height: '40px',
                                  padding: '5px 14px',
                                  borderRadius: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '6px',
                                  color: '#fff',
                                  fontWeight: '500',
                                  fontSize: '14px',
                                  boxShadow: 'none',
                                }}
                                variant="outlined"
                                size="large"
                                disabled={isMasterDownloadDisabled}
                                onClick={DownloadMasterData}
                              >
                                {isCheckingForChanges ? (
                                  <>
                                    <Spinner size="sm" />
                                    Checking for changes
                                  </>
                                ) : (
                                  <>
                                    <Download size={20} strokeWidth={1.5} />
                                    Download Master
                                  </>
                                )}
                              </CButton>

                              {showFilter && (
                                <motion.div
                                  initial={{ opacity: 0, y: 4 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: 4 }}
                                  transition={{ duration: 0.3, ease: 'easeInOut' }}
                                  style={{
                                    width: '300px',
                                    zIndex: 50,
                                    backgroundColor: '#282828',
                                    borderRadius: '10px',
                                  }}
                                  className="position-absolute gap-1 d-flex flex-column top-full left-0 z-10   shadow-lg p-4 rounded-md"
                                >
                                  <div>
                                    <CFormLabel>Facility</CFormLabel>
                                    <Select
                                      placeholder="Select"
                                      name="facility"
                                      options={facilities}
                                      value={facilities.filter((fac) => filterData.facility.includes(fac.value))}
                                      isMulti
                                      styles={{
                                        control: (base, state) => ({
                                          ...base,
                                          backgroundColor: '#191919',
                                          borderColor: state.isFocused ? '#444' : '#444',
                                          borderRadius: '6px',
                                          boxShadow: 'none',
                                          '&:hover': {
                                            borderColor: '#444',
                                          },
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          backgroundColor: '#000',
                                          borderRadius: '6px',
                                        }),
                                        option: (base, state) => ({
                                          ...base,
                                          backgroundColor: state.isSelected
                                            ? '#191919' // blue for selected
                                            : state.isFocused
                                              ? '#2a2a2a'
                                              : '#000',
                                          color: 'white',
                                          cursor: 'pointer',
                                          padding: '12px 14px',
                                          borderBottom: '1px solid #333',
                                          ':last-of-type': {
                                            borderBottom: 'none',
                                          },
                                          ':active': {
                                            backgroundColor: '#2a2a2a',
                                          },
                                        }),
                                        multiValue: (base) => ({
                                          ...base,
                                          backgroundColor: '#191919',
                                          borderRadius: '4px',
                                          border: '1px solid #454545ff',
                                        }),
                                        multiValueLabel: (base) => ({
                                          ...base,
                                          color: 'white',
                                        }),
                                        multiValueRemove: (base) => ({
                                          ...base,
                                          color: 'white',
                                          ':hover': {
                                            backgroundColor: '#333',
                                            color: 'white',
                                          },
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: 'white',
                                        }),
                                        placeholder: (base) => ({
                                          ...base,
                                          color: '#aaa',
                                        }),

                                        input: (base) => ({
                                          ...base,
                                          color: 'white',
                                        }),
                                        dropdownIndicator: (base) => ({
                                          ...base,
                                          color: 'white',
                                          ':hover': { color: 'white' },
                                        }),
                                      }}
                                      isClearable
                                      onChange={(selectedOptions) =>
                                        setFilterData((prev) => ({
                                          ...prev,
                                          facility: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                        }))
                                      }
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                    />
                                  </div>

                                  <div className="mt-2">
                                    <CFormLabel>Patient Status</CFormLabel>
                                    <Select
                                      name="status"
                                      isMulti
                                      placeholder="Select"
                                      styles={{
                                        control: (base, state) => ({
                                          ...base,
                                          backgroundColor: '#191919',
                                          borderColor: state.isFocused ? '#444' : '#444',
                                          borderRadius: '6px',
                                          boxShadow: 'none',
                                          '&:hover': {
                                            borderColor: '#444',
                                          },
                                        }),
                                        menu: (base) => ({
                                          ...base,
                                          backgroundColor: '#000',
                                          borderRadius: '6px',
                                        }),
                                        option: (base, state) => ({
                                          ...base,
                                          backgroundColor: state.isSelected
                                            ? '#191919' // blue for selected
                                            : state.isFocused
                                              ? '#2a2a2a'
                                              : '#000',
                                          color: 'white',
                                          cursor: 'pointer',
                                          padding: '12px 14px',
                                          borderBottom: '1px solid #333',
                                          ':last-of-type': {
                                            borderBottom: 'none',
                                          },
                                          ':active': {
                                            backgroundColor: '#2a2a2a',
                                          },
                                        }),
                                        multiValue: (base) => ({
                                          ...base,
                                          backgroundColor: '#191919',
                                          borderRadius: '4px',
                                          border: '1px solid #454545ff',
                                        }),
                                        multiValueLabel: (base) => ({
                                          ...base,
                                          color: 'white',
                                        }),
                                        multiValueRemove: (base) => ({
                                          ...base,
                                          color: 'white',
                                          ':hover': {
                                            backgroundColor: '#333',
                                            color: 'white',
                                          },
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: 'white',
                                        }),
                                        placeholder: (base) => ({
                                          ...base,
                                          color: '#aaa',
                                        }),

                                        input: (base) => ({
                                          ...base,
                                          color: 'white',
                                        }),
                                        dropdownIndicator: (base) => ({
                                          ...base,
                                          color: 'white',
                                          ':hover': { color: 'white' },
                                        }),
                                      }}
                                      options={selectStatusOption}
                                      isClearable
                                      value={selectStatusOption.filter((option) => filterData.status.includes(option.value))}
                                      onChange={(selectedOptions) =>
                                        setFilterData((prev) => ({
                                          ...prev,
                                          status: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                        }))
                                      }
                                      classNamePrefix="select"
                                    />
                                  </div>

                                  <div className="mt-2" style={{ position: 'relative', display: 'inline-block' }}>
                                    <CFormLabel>DOB</CFormLabel>
                                    <div>
                                      <CustomDatePickingFormat
                                        value={filterData.date || ''}
                                        aria-describedby="exampleFormControlInputHelpInline"
                                        onChange={(e) => {
                                          setFilterData((p) => ({
                                            ...p,
                                            date: e, // Keep the date in "YYYY-MM-DD" format
                                          }))
                                        }}
                                      />
                                    </div>
                                    {/* <CFormInput
                                                            type="date"
                                                            color="primary"
                                                            value={filterData.date || ""}
                                                            aria-describedby="exampleFormControlInputHelpInline"
                                                            onChange={(e) => {
                                                                setFilterData((p) => ({
                                                                    ...p,
                                                                    date: e.target.value // Keep the date in "YYYY-MM-DD" format
                                                                }));
                                                            }}
                                                        /> */}
                                  </div>

                                  <Button
                                    style={{
                                      backgroundColor: '#4363F2',
                                      border: '1px solid #333',
                                      height: '40px',
                                      padding: '5px 14px',
                                      borderRadius: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '6px',
                                      color: '#fff',
                                      fontWeight: '500',
                                      fontSize: '14px',
                                      boxShadow: 'none',
                                    }}
                                    className="mt-2"
                                    onClick={() => setShowFilter(false)}
                                    variant="outlined"
                                  >
                                    Close
                                  </Button>
                                </motion.div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="mx-3 d-flex align-items-center gap-2">
                            <div className="display-total-patient">
                              <span className="mx-1">{patientInfoCount?.newPatient || 0}</span> NP
                            </div>
                            <div className="display-total-patient">
                              <span className="mx-1">{patientInfoCount?.followUp || 0}</span> FU
                            </div>
                            <div className="display-total-patient mr-">
                              <span className="mx-1">{patientCount}</span> Patients
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0) && filteredPatientData.length === 0 && appointmentTestData == null} /> */}

                      {boxView === 'table' && (
                        <div className="custom-card-wrapper dark-patient-section" style={{ padding: '0px 0px 0px 0px', marginTop: '20px' }}>
                          {updatedFilteredPatients.length > 0 &&
                            updatedFilteredPatients.map((patient, index) => {
                              // let provider = appointment.filter(item => item.current.Patient.value === patient.PatientID);
                              const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

                              // let providerName = provider[0]?.current?.Provider?.label;
                              // let scheduleDate = provider[0]?.data?.StartTime
                              // scheduleDate = scheduleDate?.split(" ")
                              // console.log("patient data ===>", patient, provider, updatedFilteredPatients)

                              const scheduledAppointment = patientAppointments.find((p) => {
                                const status = p?.data?.Status
                                const scheduleBy = p?.data?.ScheduleBy
                                const type = p?.data?.Type
                                const isInFacility = p?.data?.isInFacility
                                const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
                                let priorAuthTime = 0
                                if (priorAuth) {
                                  priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
                                }

                                // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
                                const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
                                const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

                                return isScheduledOrRescheduled && isManualOrFollowUp
                              })

                              if (!scheduledAppointment) return null

                              const providerName = scheduledAppointment?.current?.Provider?.label
                              const scheduleDate = scheduledAppointment?.data?.StartTime?.split(' ')[0]
                              const Type = scheduledAppointment?.data?.Type

                              const isProviderAppointment = providerName === loggedUserProvider?.Name

                              if (!isProviderAppointment) return null
                              return (
                                <div key={index} className="custom-card" style={{ background: '' }}>
                                  <div className="card-header">
                                    <div>
                                      <div className="d-flex align-items-center gap-2">
                                        <p className="name-block">
                                          {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                                          <span
                                            style={{
                                              color: Type === 'New' ? 'green' : Type === 'Follow Up' ? 'orange' : 'skyblue',
                                              fontWeight: 'bold',
                                              fontSize: '0.6em',
                                            }}
                                          >
                                            ({Type === 'Follow Up' ? 'Follow Up' : Type === 'New' ? 'New Patient' : Type === 'Re Admit' ? 'Re Admit' : ''})
                                          </span>
                                        </p>
                                      </div>
                                      <div className="bullet-points">
                                        <span>{patient.Gender}</span>
                                        <span>
                                          DOB:{' '}
                                          {new Date(patient?.DOB).toLocaleDateString('en-US', {
                                            month: '2-digit',
                                            day: '2-digit',
                                            year: 'numeric',
                                          })}
                                        </span>
                                        <span>{patient.Age} Years</span>
                                      </div>
                                    </div>
                                    <div className="button-wrapper">
                                      {/* <a href="/home/scheduler"><CButton variant='outline' color='warning' className="px-2"><HiPencil size={20} /></CButton></a>
                                                        <CButton onClick={() => setShowPatientAppointmentId(patient?.PatientID)} variant='outline' color='success' className="px-2"><HiEye size={20} /></CButton>
                                                        <CButton onClick={() => openTreatmentNote(patient, scheduledAppointment?.data?.AppointmentID)} variant='outline' color='dark' className="px-2"><ExitToAppIcon size={20} /></CButton>
                                                        <CDropdown>
                                                            <CDropdownToggle
                                                                style={{
                                                                    padding: 0,
                                                                    margin: 0
                                                                }}
                                                                color="">
                                                                <CButton variant='outline' color='dark' className="calendar-button px-2"><CalendarCheck size={20} /></CButton>
                                                            </CDropdownToggle>
                                                            <CDropdownMenu>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'cancel', patient?.PatientID, patient)}>Cancel</CDropdownItem>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'finish', patient?.PatientID, patient)}>Finish</CDropdownItem>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'delete', patient?.PatientID, patient)}>Delete</CDropdownItem>

                                                            </CDropdownMenu>
                                                        </CDropdown> */}
                                      <CButton
                                        onClick={() => {
                                          // console.log(patient, "patient")
                                          // setPatientData(patient)
                                          getIntoNoteLatestHandle(patient?.PatientID, patient)
                                        }}
                                        variant="outline"
                                        color="dark"
                                        className="px-2 border-0"
                                      >
                                        <FilePenLine size={20} />
                                      </CButton>
                                    </div>
                                  </div>
                                  <div className="contact-wrapper w-100  d-flex  px-3">
                                    <div>
                                      <p className="title">Provider Name</p>
                                      <p className="value">{providerName}</p>
                                    </div>
                                    <div>
                                      <p className="title">Schedule Date</p>
                                      <p className="value">{scheduleDate}</p>
                                    </div>
                                    <div>
                                      <p className="title">Note Status</p>
                                      <p className="value">{patient?.noteStatus === 'Draft' && patient.noteFlag === 'true' ? 'Provider Draft' : patient?.noteStatus}</p>
                                    </div>
                                  </div>
                                  <div className="card-footer w-100 d-flex justify-content- align-items-start">
                                    <div className="facility mw-100">
                                      <p className="title">FACILITY NAME</p>
                                      <p className="value">
                                        {patient.FacilityName}
                                        {patient.facilityParentCompany && ` - ${patient.facilityParentCompany}`}
                                      </p>
                                    </div>
                                    <div className="room-count">
                                      <p className="title">ROOM</p>
                                      <p className="value">{patient.Room ?? ''}</p>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                      )}
                      {boxView === 'list' && (
                        <div className="hierachy-list-view d-flex flex-column gap-2" style={{ marginTop: '20px' }}>
                          <CAccordion
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '15px',
                              // background:"#fff",
                              // borderRadius:"12px"
                            }}
                            className="border-bottom-0 border-0 p-0 m-0"
                            alwaysOpen
                          >
                            {Object.entries(groupedUpdatedFilteredPatients).map(([date, facilities], dateIdx) => {
                              const totalPatientsForDate = Object.values(facilities).reduce((sum, patients) => sum + patients.length, 0)

                              return (
                                <div className="testdiv provider-page " style={{ width: '' }}>
                                  <div className="border-bottom-0 border-0 w-100" itemKey={`date-${dateIdx}`} key={date}>
                                    <div className="border-bottom-0 border-0">
                                      {date} - ({totalPatientsForDate})
                                    </div>

                                    <div className={`accordion-wrapper border-bottom-0 border-0 p-0 shadow-sm ${role == 'provider' ? 'accordion-dark' : 'accordion-light'}`} style={{ borderRadius: '40px!important' }}>
                                      <CAccordion alwaysOpen className="border-bottom-0 border-0 p-0 homeAccordion ">
                                        {Object.entries(facilities).map(([facility, patients], facIdx) => {
                                          const parentCompanyName = patients.find((patient) => patient?.facilityParentCompany)?.facilityParentCompany || ''

                                          return (
                                            <CAccordionItem className="border-bottom-0 border-0 mt-2" itemKey={`fac-${dateIdx}-${facIdx}`} key={facility}>
                                              <CAccordionHeader className="border-bottom-0 border-0 px-3 py-1 m-0 my-2  " style={{ fontSize: '14px', boxShadow: 'unset' }}>
                                                <div className="d-flex justify-content-center align-items-center gap-2">
                                                  <div className="mb-1" onClick={() => handleAddPatientData(facility, patients)}>
                                                    <CirclePlus size={18} />
                                                  </div>
                                                  <div>
                                                    {facility} - ({patients?.length}) {parentCompanyName && `- ${parentCompanyName}`}
                                                  </div>
                                                </div>
                                              </CAccordionHeader>

                                              <CAccordionBody className=" mx-3 ">
                                                <CTable responsive className=" mb-3 border-bottom-0 border-0  ">
                                                  <CTableBody className="">
                                                    {patients.length > 0 &&
                                                      patients.map((patient, index) => {
                                                        const isVerified = handleCheckVerified(patient?.appointmentID)
                                                        console.log('vierified ', patient)
                                                        const isPatientAddon = patient?.patientData?.AddonPatient ? true : false
                                                        return (
                                                          // <div className=' '>
                                                          //   {/* <Trash2 style={{ color: 'white', marginBottom: '0px' }} size={20} /> */}

                                                          // </div>
                                                          <CTableRow
                                                            className="order-0 patient-row-shadow"
                                                            //   className={`order-0 px-4 ${patient.Status === 'NewPatient' ? "NP" : patient.Status === 'Follow Up' ? "FU" : patient.Status} patient-row-list`}
                                                            key={patient.PatientID}
                                                            onClick={() => {
                                                              setSelectedPatientId(patient.PatientID)
                                                              handleCheckVerifiedData(patient?.PatientID, patient, patient?.appointmentID)

                                                              if (timeoutRef.current) clearTimeout(timeoutRef.current)
                                                              setTimeout(() => {
                                                                setSelectedPatientId(null)
                                                              }, 10000)
                                                            }}
                                                            style={{
                                                              cursor: 'pointer',
                                                              verticalAlign: 'middle',
                                                              gap: '20px',
                                                              margin: '10px 2px',
                                                              background: '#1E1E1E',
                                                              boxShadow: selectedPatientId === patient.PatientID ? '0 0 10px #ffffff' : '0 0 4px rgba(0, 0, 0, 0.5)',
                                                              borderRadius: '6px',
                                                              transition: 'all 0.25s ease-in-out',
                                                            }}
                                                            onMouseEnter={(e) => {
                                                              if (selectedPatientId !== patient.PatientID) {
                                                                e.currentTarget.style.boxShadow = '0 0 8px rgba(255,255,255,0.2)'
                                                              }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                              if (selectedPatientId !== patient.PatientID) {
                                                                e.currentTarget.style.boxShadow = '0 0 4px rgba(0, 0, 0, 0.5)'
                                                              }
                                                            }}
                                                          >
                                                            <CTableDataCell className="border-bottom-0 border-0 p-0" scope="row">
                                                              <span className="patient-name-fixed d-flex align-items-center gap-2 text-white" style={{ fontWeight: '100' }}>
                                                                <span
                                                                  style={{
                                                                    width: '10px',
                                                                    height: '10px',
                                                                    background: patient?.Status === 'NewPatient' ? 'green' : patient?.Status === 'Follow Up' ? 'orange' : 'gray',
                                                                    display: 'block',
                                                                    borderRadius: '50px',
                                                                  }}
                                                                ></span>
                                                                {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                                                              </span>
                                                            </CTableDataCell>
                                                            <CTableDataCell className="d-flex align-items-center justify-content-end border-bottom-0 border-0">
                                                              {isPatientAddon && (
                                                                <span
                                                                  style={{
                                                                    minWidth: 'fit-content',
                                                                  }}
                                                                  className="room-pill"
                                                                >
                                                                  Add on
                                                                </span>
                                                              )}
                                                              <span className="room-pill"> Room : {patient?.Room}</span>
                                                              {patient?.patientSeen === false && <span className="schedule1-pill">Not Seen : {patient?.notSeenReason}</span>}

                                                              {isVerified ? (
                                                                <span className="ms-2">
                                                                  <Check style={{ color: 'white', width: '18px', height: '18px' }} />
                                                                </span>
                                                              ) : (
                                                                <span className="ms-2">
                                                                  <X style={{ color: 'white', width: '18px', height: '18px' }} />
                                                                  {/* {patient?.AddedByApp && <Trash style={{ color: 'white', width: '18px', height: '18px' }} />} */}
                                                                </span>
                                                              )}

                                                              {/* <motion.span
                                                              whileHover={{ scale: 1.2 }}
                                                              onClick={async (e) => {
                                                                e.preventDefault()
                                                                e.stopPropagation()
                                                                await GetPatientTreatmentsNotesForParticularPatient(patient?.PatientID)
                                                              }}
                                                              className="ms-2">
                                                              <ArrowDownToLine style={{ color: 'white', width: '18px', height: '18px' }} />
                                                              //{patient?.AddedByApp && <Trash style={{ color: 'white', width: '18px', height: '18px' }} />}
                                                            </motion.span> */}

                                                              {/* <span className="notestatus-pill"> {patient?.Status === 'NewPatient' ? 'New Patient' : patient?.Status}</span> */}
                                                              <span></span>
                                                              {/* <CButton
                                                  className="border-0"
                                                  variant="outline"
                                                  style={{ fontSize: '14px', color: 'white' }}
                                                  onClick={() => {
                                                    getIntoNoteLatestHandle(patient?.PatientID, patient)
                                                  }}
                                                >
                                                  <FilePenLine />
                                                </CButton> */}
                                                            </CTableDataCell>
                                                          </CTableRow>
                                                        )
                                                      })}
                                                  </CTableBody>
                                                </CTable>
                                              </CAccordionBody>
                                            </CAccordionItem>
                                          )
                                        })}
                                      </CAccordion>
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                            {Object.keys(groupedUpdatedFilteredPatients).length === 0 && (
                              <div className="d-flex justify-content-center align-items-start text-muted">
                                <div
                                  style={{
                                    padding: '40px',
                                    fontSize: '15px',
                                    fontWeight: '600px',
                                    color: 'gray',
                                  }}
                                >
                                  No Appointments Available
                                </div>
                              </div>
                            )}
                          </CAccordion>
                        </div>
                      )}

                      {/* <CustomAgGrid callFrom="Patient" rowClickedFn={patientSelected} options={patientData} btnList={buttonList}></CustomAgGrid> */}

                      <CModal size="lg" visible={patientModelVisible} onClose={() => setPatientModalVisible(false)}>
                        {/* patientData, patientID, setPatientModalVisible, setDataCallType, setShowPatientInfo, setEditDataId, setNoteID, patientSelected, childformData, setChildFormData, saveDiagnosisData */}
                        <CModalBody className="view-data-modal" style={{ padding: '2rem', borderRadius: '2rem', overflow: 'auto' }}>
                          {
                            <PatientPopup
                              creatingNewNote={creatingNewNote}
                              setCreatingNewNote={setCreatingNewNote}
                              noteStatus={noteStatus}
                              setNoteStatus={setNoteStatus}
                              patientSelected={patientSelected}
                              setNoteID={setNoteID}
                              childformData={childformData}
                              setChildFormData={setChildFormData}
                              saveDiagnosisData={saveDiagnosisData}
                              patientID={patientIDClicked}
                              patientData={rowClicked}
                              noteStructureRef={noteStructureRef}
                              setPatientModalVisible={setPatientModalVisible}
                              dataCallType={dataCallType}
                              setDataCallType={setDataCallType}
                              setEditDataId={setEditDataId}
                              setShowPatientInfo={setShowPatientInfo}
                              setAllSelectedDiagnosis={setAllSelectedDiagnosis}
                              patientAppointmentID={patientAppointmentID}
                              appointment={appointment}
                              viewPatientDetail={viewPatientDetail}
                              handleAddNoteId={handleAddNoteId}
                              showViewIcon={true}
                            />
                          }
                        </CModalBody>
                        <CModalFooter>
                          <Button variant="outlined" onClick={() => setPatientModalVisible(false)}>
                            Close
                          </Button>
                        </CModalFooter>
                      </CModal>

                      <CModal
                        size="lg"
                        visible={modalVisible}
                      // onClose={resetStates}
                      >
                        <CModalHeader
                          style={{
                            backgroundColor: '#282828',
                            borderBottom: '1px solid gray',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            borderRadius: '10px 10px 0 0',
                          }}
                        >
                          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Add Patient</CModalTitle>
                        </CModalHeader>

                        <CModalBody
                          style={{
                            backgroundColor: '#282828',
                            color: 'white',
                          }}
                        >
                          <div className="m-3">
                            <AddProviderPatientForm formData={childformData} setFormData={setChildFormData} facility={facility} setFacility={setFacility} errors={formValidationErrors} />
                          </div>
                        </CModalBody>
                        <CModalFooter
                          style={{
                            backgroundColor: '#282828',
                            borderTop: '1px solid gray',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '10px',
                            borderRadius: '0 0 10px 10px',
                          }}
                        >
                          <Button
                            style={{
                              backgroundColor: '#333',
                              border: '1px solid gray',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            variant="outlined"
                            onClick={() => {
                              resetStates(), setPatientID('')
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            style={{
                              backgroundColor: '#4363F2',
                              border: 'none',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            disabled={creatingPatientLoader}
                            variant="contained"
                            onClick={() => handlePatientSubmit()}
                          >
                            {' '}
                            {creatingPatientLoader ? <CircularProgress className="text-white p-1" size={20} /> : 'Submit'}
                          </Button>
                        </CModalFooter>
                      </CModal>

                      {/* Edit patient */}
                      <CModal size="lg" visible={editModalVisible} onClose={() => setEditModalVisible(false)}>
                        <CModalHeader
                          style={{
                            backgroundColor: '#191919',
                            borderBottom: '1px solid gray',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            borderRadius: '10px 10px 0 0',
                          }}
                        >
                          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Edit Patient</CModalTitle>
                        </CModalHeader>

                        <CModalBody
                          style={{
                            backgroundColor: '#191919',
                            color: 'white',
                          }}
                        >
                          <div className="m-3">
                            <AddProviderPatientForm formData={childformData} setFormData={setChildFormData} facility={facility} setFacility={setFacility} errors={formValidationErrors} />
                          </div>
                        </CModalBody>
                        <CModalFooter
                          style={{
                            backgroundColor: '#191919',
                            borderTop: '1px solid gray',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '10px',
                            borderRadius: '0 0 10px 10px',
                          }}
                        >
                          <Button
                            style={{
                              backgroundColor: '#333',
                              border: '1px solid gray',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            variant="outlined"
                            onClick={() => {
                              resetStates()
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            style={{
                              backgroundColor: '#4363F2',
                              border: 'none',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            disabled={creatingPatientLoader}
                            variant="contained"
                            onClick={() => handleEditPatinetSubmit()}
                          >
                            {' '}
                            {creatingPatientLoader ? <CircularProgress className="text-white p-1" size={20} /> : 'Update'}
                          </Button>
                        </CModalFooter>
                      </CModal>

                      <CModal size="lg" visible={showVerifyModel} onClose={() => setShowVerifyModel(false)}>
                        <CModalHeader
                          style={{
                            backgroundColor: '#282828',
                            borderBottom: '1px solid gray',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            borderRadius: '10px 10px 0 0',
                          }}
                        >
                          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }} className="d-flex justify-content-center">
                            Patient Details{' '}
                            <span className="ms-2" onClick={() => handleEditPatient(verifyPatientData)}>
                              <Pencil size={17} />{' '}
                            </span>
                          </CModalTitle>
                        </CModalHeader>

                        <CModalBody
                          style={{
                            backgroundColor: '#282828',
                            color: 'white',
                          }}
                        >
                          <div className=" m-3 p-4">
                            <CRow className="mb-3">
                              <CCol md={2}>First Name</CCol>
                              <CCol className="text-white">{verifyPatientData?.FirstName}</CCol>
                            </CRow>
                            <CRow className="mb-3">
                              <CCol md={2}>Middle Name</CCol>
                              <CCol className="text-white">{verifyPatientData?.MiddleName}</CCol>
                            </CRow>
                            <CRow className="mb-3">
                              <CCol md={2}>Last Name</CCol>
                              <CCol className="text-white">{verifyPatientData?.LastName}</CCol>
                            </CRow>

                            <CRow className="mb-3">
                              <CCol md={2}>Age</CCol>
                              <CCol className="text-white">{verifyPatientData?.Age}</CCol>
                            </CRow>
                            <CRow className="mb-3">
                              <CCol md={2}>Gender</CCol>
                              <CCol className="text-white">{verifyPatientData?.Gender}</CCol>
                            </CRow>
                            <CRow className="mb-3">
                              <CCol md={2}>Room</CCol>
                              <CCol className="text-white">{verifyPatientData?.Room}</CCol>
                            </CRow>
                            <CRow className="mb-3">
                              <CCol md={2}>Facility Type</CCol>
                              <CCol className="text-white">
                                {' '}
                                <div
                                  style={{
                                    display: 'flex',
                                    width: '250px',
                                    overflow: 'hidden',
                                    // borderRadius: '8px',
                                    // border: '1px solid #464646ff',
                                    height: '40px',
                                  }}
                                >
                                  <button
                                    className="px-3"
                                    style={{
                                      borderRadius: '0px',
                                      border: 0,
                                      background: verifyFormData?.term === 'Short Term' ? 'green' : 'unset',
                                      color: 'white',
                                      fontSize: '14px',
                                      outline: ' none',
                                      borderRadius: '8px',
                                      border: '1px solid #464646ff',
                                    }}
                                    onClick={() => handleVerifyButton('term', 'Short Term')}
                                  >
                                    Short Term
                                  </button>

                                  <button
                                    className="px-4"
                                    style={{
                                      borderRadius: '0px',
                                      border: 0,
                                      background: verifyFormData?.term === 'Long Term' ? 'green' : 'unset',
                                      color: 'white',
                                      fontSize: '14px',
                                      outline: ' none',
                                      borderRadius: '8px',
                                      border: '1px solid #464646ff',
                                      marginLeft: '10px',
                                    }}
                                    onClick={() => handleVerifyButton('term', 'Long Term')}
                                  >
                                    Long Term
                                  </button>
                                </div>
                              </CCol>
                            </CRow>
                            <CRow className="mb-3">
                              <CCol md={2}>DOB</CCol>
                              <CCol className="text-white">{verifyPatientData?.DOB}</CCol>
                            </CRow>
                            <CRow className="mb-3">
                              <CCol md={2}>Patient in Facility</CCol>
                              <CCol className="text-white">
                                <div
                                  style={{
                                    display: 'flex',
                                    width: 'min-content',
                                    overflow: 'hidden',
                                    borderRadius: '8px',
                                    border: '1px solid #464646ff',
                                    height: '40px',
                                  }}
                                >
                                  <button
                                    className="px-3"
                                    style={{
                                      borderRadius: '0px',
                                      border: 0,
                                      background: verifyFormData?.patientSeen === true ? 'green' : 'unset',
                                      color: 'white',
                                      fontSize: '14px',
                                      outline: ' none',
                                      border: 'none',
                                    }}
                                    onClick={() => handleVerifyButton('patientSeen', true)}
                                  >
                                    Yes
                                  </button>

                                  <button
                                    className="px-4"
                                    style={{
                                      borderRadius: '0px',
                                      border: 0,
                                      background: verifyFormData?.patientSeen === false ? 'green' : 'unset',
                                      color: 'white',
                                      fontSize: '14px',
                                      outline: ' none',
                                      border: 'none',
                                    }}
                                    onClick={() => handleVerifyButton('patientSeen', false)}
                                  >
                                    No
                                  </button>
                                </div>
                              </CCol>
                            </CRow>
                            {verifyFormData?.patientSeen == false && (
                              <CRow className="mb-3">
                                <CCol md={2}> </CCol>
                                <CCol className="text-white">
                                  <Select
                                    options={verifyPatinetOption}
                                    value={verifyPatinetOption.find((opt) => opt.label === verifyFormData.notSeenReason) || null}
                                    onChange={(val) =>
                                      setVerifyFormData((prev) => ({
                                        ...prev,
                                        notSeenReason: val?.label,
                                      }))
                                    }
                                    placeholder="Select an option"
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        borderRadius: '8px',
                                        boxShadow: 'none',
                                        borderColor: '#6f6f6fff',
                                        background: '#191919',
                                        color: 'white',
                                        border: '1px solid gray',
                                        outline: 'none',
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        backgroundColor: '#000000',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                      }),
                                      option: (base, state) => ({
                                        ...base,
                                        color: 'white',
                                        backgroundColor: state.isFocused ? '#333333' : '#000000',
                                        cursor: 'pointer',
                                        padding: '10px 12px',
                                      }),
                                      singleValue: (base) => ({
                                        ...base,
                                        color: 'white',
                                      }),
                                      placeholder: (base) => ({
                                        ...base,
                                        color: '#9ca3af',
                                      }),
                                      dropdownIndicator: (base) => ({
                                        ...base,
                                        color: 'white',
                                      }),
                                      indicatorSeparator: (base) => ({
                                        ...base,
                                        backgroundColor: '#444',
                                      }),
                                    }}
                                  />
                                </CCol>
                              </CRow>
                            )}
                            {verifyFormData?.notSeenReason == 'Other' && (
                              <CRow className="mb-3">
                                <CCol md={2}> </CCol>
                                <CCol className="text-white">
                                  <CCol>
                                    <CFormTextarea
                                      className="custom-input"
                                      style={{ background: '#191919', border: '1px solid #464646ff', color: 'white' }}
                                      value={verifyFormData.otherReason}
                                      placeholder="Other reasons"
                                      onChange={(e) => setVerifyFormData((prev) => ({ ...prev, otherReason: e.target.value }))}
                                      rows={3}
                                    />
                                  </CCol>
                                </CCol>
                              </CRow>
                            )}
                            {/* <CRow className="mb-3">
                      <CCol md={2}></CCol>
                      <CCol className="text-white">
                        <CButton
                          className="px-4"
                          style={{
                            borderRadius: '0px',
                            border: 0,
                            background: '#4363F2',
                            color: 'white',
                            fontSize: '16px',
                            outline: ' none',
                            borderRadius: '8px',
                            border: '1px solid #464646ff',
                            width:'120px'
                          }}
                          // onClick={() => handleVerifyCButton('term', 'Long Term')}
                        >
                          <span>
                            
                            <PenIcon size={15} /> 
                          </span>{' '}
                          Edit
                        </CButton>
                      </CCol>
                    </CRow> */}
                          </div>
                        </CModalBody>
                        <CModalFooter
                          style={{
                            backgroundColor: '#282828',
                            borderTop: '1px solid gray',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '10px',
                            borderRadius: '0 0 10px 10px',
                          }}
                        >
                          <Button
                            style={{
                              backgroundColor: '#333',
                              border: '1px solid gray',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            variant="outlined"
                            onClick={() => {
                              cleaerVerifyForm()
                            }}
                          >
                            Close
                          </Button>
                          <CButton
                            style={{
                              backgroundColor: '#4363F2',
                              border: 'none',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            disabled={verifyFormData.term !== '' ? false : true}
                            variant="contained"
                            onClick={() => handleVerifySubmit(verifyPatientData)}
                          >
                            Verify
                          </CButton>

                          {verifyPatientData?.AddedByApp && (
                            <CButton
                              style={{
                                backgroundColor: 'red',
                                border: 'none',
                                color: 'white',
                                borderRadius: '6px',
                                padding: '8px 20px',
                              }}
                              variant="contained"
                              onClick={() => handleDeletePatientData(verifyPatientData?.PatientID)}
                            >
                              Delete
                            </CButton>
                          )}
                        </CModalFooter>
                      </CModal>

                      <CModal visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
                        <CModalHeader
                          style={{
                            backgroundColor: '#191919',
                            borderBottom: '1px solid gray',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            borderRadius: '10px 10px 0 0',
                          }}
                        >
                          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Warning</CModalTitle>
                        </CModalHeader>
                        <CModalBody
                          style={{
                            backgroundColor: '#191919',
                            color: 'white',
                          }}
                        >
                          <p>Are you sure you want to delete this patient ?</p>
                        </CModalBody>

                        <CModalFooter
                          style={{
                            backgroundColor: '#191919',
                            borderTop: '1px solid gray',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '10px',
                            borderRadius: '0 0 10px 10px',
                          }}
                        >
                          <CButton
                            onClick={() => {
                              setDeleteVisible(false)
                            }}
                            className="text-white"
                            color="secondary"
                            variant="outline"
                          >
                            Close
                          </CButton>
                          <CButton onClick={() => handleDeletePatient()} className="text-white" color="danger">
                            Delete
                          </CButton>
                        </CModalFooter>
                      </CModal>

                      <CModal backdrop="static" size="lg" alignment="center" visible={downloadingData} onClose={() => setDownloadingData(false)}>
                        <CModalBody
                          style={{
                            backgroundColor: '#191919',
                            color: 'white',
                          }}
                        >
                          <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}></div>

                            {downloadingData && (
                              <div>
                                <div className=" ">
                                  <div className="d-flex align-items-center justify-content-center gap-0 ">
                                    <div className="">
                                      <CAvatar src={logo} className="rounded-0" style={{ width: '90px', height: '90px' }} />
                                    </div>
                                    <span
                                      style={{
                                        color: '#4FC3F7',
                                        fontSize: '18px',
                                        padding: '0 0',
                                        marginLeft: '1px',
                                      }}
                                    >
                                      Provio Solutions
                                    </span>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    position: 'relative',
                                    maxWidth: '600px',
                                    margin: '0 auto',
                                  }}
                                >
                                  {steps.map((step, index) => {
                                    const isCompleted = step.id < currentStep
                                    const isCurrent = step.id === currentStep
                                    const isUpcoming = step.id > currentStep

                                    return (
                                      <React.Fragment key={step.id}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            flex: index === steps.length - 1 ? '0 0 auto' : '0 0 auto',
                                            zIndex: 2,
                                            marginRight: step.id === 1 ? '15px' : step.id === 2 ? '0' : step.id === 3 ? '0' : '0',
                                            marginLeft: step.id === 1 ? '0' : step.id === 2 ? '0' : step.id === 3 ? '20px' : '0',
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: '50px',
                                              height: '50px',
                                              borderRadius: '50%',
                                              backgroundColor: isCompleted ? '#5BA3D0' : isCurrent ? '#8BC34A' : '#444',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              color: '#fff',
                                              fontSize: '20px',
                                              fontWeight: 'bold',
                                              transition: 'all 0.3s ease',
                                              marginBottom: '12px',
                                            }}
                                          >
                                            {step.id}
                                          </div>

                                          <span
                                            style={{
                                              fontSize: '14px',
                                              color: isCompleted || isCurrent ? '#e0e0e0' : '#666',
                                              fontWeight: isCurrent ? '600' : '400',
                                              whiteSpace: 'nowrap',
                                              transition: 'all 0.3s ease',
                                            }}
                                          >
                                            {step.label}
                                          </span>
                                        </div>

                                        {index < steps.length - 1 && (
                                          <div
                                            style={{
                                              flex: 1,
                                              height: '8px',
                                              backgroundColor: step.id < currentStep ? '#5BA3D0' : '#333',
                                              margin: '0 -25px',
                                              marginBottom: '42px',
                                              transition: 'background-color 0.3s ease',
                                              zIndex: 1,
                                            }}
                                          />
                                        )}
                                      </React.Fragment>
                                    )
                                  })}
                                </div>

                                <div
                                  style={{
                                    textAlign: 'center',
                                    marginTop: '40px',
                                    fontSize: '14px',
                                    color: '#999',
                                    fontWeight: '300',
                                    color: 'white',
                                  }}
                                >
                                  {inProcessText} {progress}% ({elapsedTime}) sec
                                </div>
                              </div>
                            )}
                          </div>
                        </CModalBody>

                        <CModalFooter
                          style={{
                            backgroundColor: '#191919',
                            borderTop: '1px solid gray',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '10px',
                            borderRadius: '0 0 10px 10px',
                          }}
                        >
                          <CButton
                            onClick={() => {
                              cancelRequested.current = true
                              setDeleteVisible(false)
                            }}
                            style={{
                              backgroundColor: '#4363F2',
                              border: 'none',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            variant="outline"
                          >
                            Cancel
                          </CButton>
                        </CModalFooter>
                      </CModal>

                      <CModal visible={masterModel} onClose={() => setMasterModel(false)}>
                        <CModalHeader
                          style={{
                            backgroundColor: '#191919',
                            borderBottom: '1px solid gray',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            borderRadius: '10px 10px 0 0',
                          }}
                        >
                          <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Download Master</CModalTitle>
                        </CModalHeader>
                        <CModalBody
                          style={{
                            backgroundColor: '#191919',
                            color: 'white',
                          }}
                        >
                          <p>Please download master before continuing</p>
                        </CModalBody>

                        <CModalFooter
                          style={{
                            backgroundColor: '#191919',
                            borderTop: '1px solid gray',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                            padding: '10px',
                            borderRadius: '0 0 10px 10px',
                          }}
                        >
                          <CButton
                            onClick={() => {
                              setMasterModel(false)
                            }}
                            style={{
                              backgroundColor: '#4363F2',
                              border: 'none',
                              color: 'white',
                              borderRadius: '6px',
                              padding: '8px 20px',
                            }}
                            variant="outline"
                          >
                            Close
                          </CButton>
                        </CModalFooter>
                      </CModal>
                    </div>
                  </CTabPane>
                  <CTabPane visible={activeKey === 2}>{activeKey === 2 && <UploadPatient />}</CTabPane>
                </CTabContent>
              </div>

              {/* {appointmentTestData == null ? (
                <Pageloader isLoading={true} />
              ) : appointmentTestData.length > 0 ? (
                <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0) && filteredPatientData.length === 0} />
              ) : (
                <div style={{ color: 'gray', display: 'flex', justifyContent: 'center ', marginTop: '200px' }}> </div>
              )} */}
            </div>
            <CModal backdrop="static" size="lg" alignment="center" visible={isRefreshLoad} onClose={() => setIsRefreshLoad(false)}>
              <CModalBody style={{ backgroundColor: '#191919', color: 'white' }}>
                <div className="text-center ">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <CAvatar src={logo} className="rounded-0" style={{ width: '90px', height: '90px' }} />
                    <span style={{ color: '#4FC3F7', fontSize: '18px', marginLeft: '1px' }}>Provio Solutions</span>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '20px' }}>
                    <div style={{ width: '60%' }}>
                      {' '}
                      <CProgress className="w-100" height={5}>
                        <CProgressBar value={appointmentProgress} color="info" animated />
                      </CProgress>
                      <p style={{ marginTop: '5px', color: '#aaa', fontSize: '14px', textAlign: 'center' }}>Downloading Patients - {Math.round(appointmentProgress)}%</p>
                    </div>
                  </div>
                </div>
              </CModalBody>

              <CModalFooter
                style={{
                  backgroundColor: '#191919',
                  borderTop: '1px solid gray',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  padding: '10px',
                  borderRadius: '0 0 10px 10px',
                }}
              >
                <CButton onClick={() => setIsRefreshLoad(false)} style={{ backgroundColor: '#4363F2', border: 'none', color: 'white', borderRadius: '6px', padding: '8px 20px' }} variant="outline">
                  Cancel
                </CButton>
              </CModalFooter>
            </CModal>

            {/* Downloading For Particular Patient */}
            <CModal backdrop="static" size="lg" alignment="center" visible={isRefreshLoadForParticulatPatient} onClose={() => setIsRefreshLoadForParticulatPatient(false)}>
              <CModalBody style={{ backgroundColor: '#191919', color: 'white' }}>
                <div className="text-center ">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <CAvatar src={logo} className="rounded-0" style={{ width: '90px', height: '90px' }} />
                    <span style={{ color: '#4FC3F7', fontSize: '18px', marginLeft: '1px' }}>Provio Solutions</span>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '20px' }}>
                    <div style={{ width: '60%' }}>
                      {' '}
                      <CProgress className="w-100" height={5}>
                        <CProgressBar value={appointmentProgress} color="info" animated />
                      </CProgress>
                      <p style={{ marginTop: '5px', color: '#aaa', fontSize: '14px', textAlign: 'center' }}>
                        Downloading {downloadPatientName} Details - {Math.round(appointmentProgress)}%
                      </p>
                    </div>
                  </div>
                </div>
              </CModalBody>

              <CModalFooter
                style={{
                  backgroundColor: '#191919',
                  borderTop: '1px solid gray',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  padding: '10px',
                  borderRadius: '0 0 10px 10px',
                }}
              >
                <CButton onClick={() => setIsRefreshLoadForParticulatPatient(false)} style={{ backgroundColor: '#4363F2', border: 'none', color: 'white', borderRadius: '6px', padding: '8px 20px' }} variant="outline">
                  Cancel
                </CButton>
              </CModalFooter>
            </CModal>

            {/* <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0) && filteredPatientData.length === 0 && appointmentTestData == null} /> */}
          </div>
        )}
      </div>
    </>
  )
}
export default ProviderTodaysAppointment3
